"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BEDEK_EXAMPLES = void 0;
exports.BEDEK_EXAMPLES = `
# Bedek Data

## нет значка на вх.двери / סימון לדלת הכניסה

ליקוי: לא בוצע סימון לדלת הכניסה.
חוסר הסימון יוצר מצב של חוסר וודאות לגבי תקניות הדלת.
על פי הוראות תקן 5044.1 ו – 1004.2, נדרשת תווית סימון הכוללות את פרטי היצרן של הדלת את רמת הדירוג אקוסטי, בהתאם לטבלה 2 המוצגת להלן.
נדרש:
א. לספק אסמכתאות בעניין תקניות דלת הכניסה.
ב. החלפת הדלת, במידה ויתברר כי הדלת איננה תקנית.
מצ"ב ציטוט מת"י 5044.1

מצ"ב ציטוט מת"י 1004.2


## סף דל הכניסה - גובה

ליקוי: מעבר מדורג בסף דל הכניסה לדירה בוצע בגובה לא אחיד.
{{location}}
נדרש: כיוון עד לקבלת מרווח תקני.

## פגמים/שריטות בדלת כניסה / Вмятины (царапина) на вх.двери

ליקוי: הובחנה שריטה בציפוי הדלת, זאת בניגוד לתקן 5044 חלק 1 ,סעיף 3.1.13
נדרש: לבצע תיקון מקומי בציפוי הדלת, לעיתים לאחר ביצוע תיקון מקומי רואים הבדלי גוון ו הבדלי טקסטורה, במידה ולאחר ביצוע תיקון מקומי יראו סימני תיקון, יידרש יהיה להעביר את הדלת למצבעה לצביעה אצל יצרן הדלת


## שריטות בידית הדלת / царапина на дверных ручках

ליקוי: שריטות בידית הדלת.
{{location}}
נדרש: להחליף את ידית.

## גמר לקוי במלבן הדלת / плохая покраска  машкофа двери

ליקוי: אותרו שריטות, פגמים ואי-אחידות בצביעת מלבן דלת המתכת, בניגוד לדרישות תקן 1922 חלק 2, סעיף 4.3.3.2.
נדרש:
1.  גירוד שכבת הצבע הקיימת ממסגרת הדלת.
2. יישום מחדש של הצבע, כולל שכבת צבע יסוד וצבע גמר תקני.
3. אפשרות נוספת: שימוש בצבע דו-רכיבי איכותי לעמידות גבוהה יותר.

## מנעול הביטחון לא עובד / сэгэр битахон не работает

ליקוי: מנעול הביטחון הורכב בצורה לא תקינה ולא מתפקד כראוי.
נדרש: לשנות את הרכבת מנעול הביטחון למצב תקין.

## דלת לא נסגרת (כיוון דלת) / дверь не закрывается (кривая)

ליקוי: קיים רווח משתנה בין אגף הדלת למלבן הדלת, בניגוד לדרישות התקן הישראלי ת"י 23 חלק 2, דבר שעלול לפגוע באטימות ובתפקוד התקני של דלת.
נדרש:
- כיוון מחדש של אגף הדלת והצירים להשגת רווח אחיד בהתאם לדרישות התקן.
- ווידוא סגירה תקינה ואטימה מלאה של הדלת.

## גומייה לא תקינה / Гумия лакуйя

ליקוי: פס גומי אטימה במשקוף הדלת/כנף הדלת פגום ואינו יוצר אטימה מוחלטת, וזאת בניגוד לתקן 5044 חלק 2 משנת 2003 סעיף 3.3.1.
נדרש: יש לפרק את האטימה הקיימת לנקות שיירי דבק ולהתקין גומי אטימה חדש.


## פגמים בדלת / вмятины на дверях

ליקוי: פגמים בציפוי הדלת , הפוגעים במראה האסתטי וייתכן שגם בעמידות החומר, וזאת בניגוד להנחיות תקן ישראלי 23 חלק 1.
נדרש: לבצע תיקון נקודתי לציפוי הדלת או להחליף את הדלת במידת הצורך.


2.12.1 פגמים חזותיים
בודקים כמתואר לגבי נושא זה בסעיף "מראה פני השטח" בתקן הישראלי ת"י 507 חלק 1, לפי העניין. בודקים אם מצויים בפני הציפוי פגמים אלה: טביעות אצבעות, כתמים זרים, מריחות צבע, חוסר אחידות בגוון שאינו נובע מטיב העץ ומגונו, חלקים זרים, שריטות וקילוף.
ועל פי תקן ישראלי ת"י 23 , חלק 3, ציטוט:

ועל פי תקן ישראלי ת"י 23 , חלק 3, ציטוט:


פגמים חזותיים
בודקים בבדיקה זו גם את הפיאה העליונה והפיאות הצדדיות של הדלת.
בבדיקה ממרחק 2 מ' מהדלת, לא ייראה בציפוי אף אחד מהפגמים המתוארים בסעיף "פגמים חזותיים" בתקן הישראלי ת"י 23 חלק 1, ולא תיראה היפרדות של הציפוי במקצועות הדלת.



## משקוף דלת ו/או חלון חלול עם מרווח בין הלבשה לקיר /  Нет милуя между машкофом (дверь/окно) со стеной

ליקוי: משקוף דלת ו/או חלון ו/או ויטרינה חלול עם מרווח בין ההלבשה לקיר עקב חוסר במילוי תקני. מצב זה עלול לגרום לסדקים, התקלפות ולגימור פגום בקיר הסמוך, בניגוד להוראות תקן 4068.1.
נדרש: למלא את המרווח בחומר אלסטומרי מתאים ולהבטיח חיבור יציב ואסתטי של ההלבשה לקיר.


## ידית רופפת / ручка двери шатается

ליקוי: ידית הדלת רופפת ואינה מקובעת כראוי, דבר שעלול להוביל לתפקוד לקוי או נזק נוסף.
נדרש:
1. חיזוק הידית באמצעות הידוק הברגים.
2. מידת הצורך, החלפת החלקים הפנימיים של הידית או התקנת ידית חדשה.

## מלבן/משקוף עקום / Машкоф двери кривой

ליקוי: מלבן עקום.
{{location}}
זאת בניגוד לת"י 23 חלק 1.
נדרש: פירוק מלבן עקום והרכבת מחדש, מפולס.

## לוח חשמל לא מושלם / нет пкаков в эл.щитке

ליקוי: לוח חשמל לא מושלם.
זאת בניגוד למפרט 165 (תיבות ללוחות חיבורים למתקני חשמל) סעיף 4 .
נדרש: להשלים פסים מ P.V.C במקומות החסרים.

## סימון לוח חשמל / нет надписей в эл.щитке

ליקוי: לא בוצע סימון למתגים החשמליים בלוח החשמל וזאת כנדרש ע"פ תקנות החשמל (התקנת לוחות במתח עד 1000 וולט) פרק ד' סעיף מס' 14 , ציטוט:

נדרש: יש לבצע סימון מפסקי המעגלים החשמליים בלוח החשמל.

## שקע מוגן מים / резетка не защещенная от воды (под киёром митбаха/ балкон/х.рахаца)

ליקוי: שקע חשמלי במקום החשוף למים אינו מוגן מרטיבות וזאת בניגוד לתקנות החשמל.
{{location}}
נדרש: להחליף את השקע.

## שקעים / מפסקים עקומים / кривые розетки

ליקוי: שקעים ו/או מפסקים חשמליים מותקנים בצורה עקומה.
נדרש: פירוק השקעים ו/או המפסקים והתקנה מחדש באופן ישר ומדויק, בהתאם לסטנדרטים המקובלים.

## נקודות חשמל לא בקו אחיד / эл. точки (розетки) не на одной линии

ליקוי: נקודות החשמל הסמוכות אינן מורכבות בקו אחיד, מה שפוגע באסתטיקה ועלול להעיד על התקנה לא מדויקת.
נדרש: ליישר את הנקודות ולהתקינן מחדש בקו אחיד.

## מבנה לוח חשמל לא נסגר / крыша эл.считка не закрывается

ליקוי: מבנה לוח  הורכב בצורה לא תקינה ולא מתפקד כראוי.
{{location}}
נדרש לפרק מבנה לוח חשמל/תקשורת ולהרכיב בצורה ישרה, כך שהדלתות יסגרו בצורה תקינה.

## גופי תאורה (מנורות) אינם מקובעים היטב לתקרה / плохое крепление ламп к потолку

ליקוי: גופי תאורה במקומות פזורים ברחבי הדירה אינם מקובעים היטב לתקרה. תקנות החשמל (מעגלים סופיים הניזנים ממתח עד 1000 וולט), התשמ" ה– 1984, סעיף 28 (א').מנורה המורכבת על קיר או על תקרה תקבע באופן יציב ובחיזוק בר קיימא.
נדרש: יש לחזק ולקבע נקודות התאורה (פנדלים) לקיר/תקרה שלא יהווה מפגע בטיחותי.

## לא הותקן שקע חשמלי בארון תקשורת / нет резетки в арон тикшорет

ליקוי: לא הותקן שקע חשמלי בארון תקשורת.
נדרש: להתקין שקע חשמלי בארון תקשורת.

## טרם הורכבו מכסים בקופסאות חשמל / Крышки в распределительных коробках / выключателях еще не установлены

ליקוי: טרם הורכבו מכסים לשקעים ולמתגים.
נדרש: התקנת מכסים מתאימים לכל השקעים והמתגים.
זאת בניגוד למפרט הכללי הבין משרדי לבניה ( הספר הכחול ) סעיף 08.
ובניגוד לתקנות החשמל (התקנת מוליכים) משנת 1970 סעיף 42 הקובע כי: "תיבה ואבזר יהיו תקניים ובנויים באופן שיבטיחו את כל אלה או מקצתם לפי העניין… (2) הגנה בפני מגע מקרי בחלקים החיים שבתוכם; (3) אטימה נאותה בפני חדירת גזים, מים, אבק וחומרים מזיקים אחרים, הכל לפי מקום ההתקנה ".

## גמר לקוי  סביב שקעי ומפסקי החשמל / вокруг резеток и перекл. плохой финиш

ליקוי: גמר לקוי ובלתי אסתטי סביב שקעי ומפסקי החשמל (נתגלו שקעי חשמל ומתגים עם שאריות צבע ומסביבם צבע שאינו מיושם כיאה. חלק מהשקעים אינם מעוגנים לקיר כנדרש וחלקם בולטים יתר על המידה באופן לא אחיד.), וזאת בניגוד לכללי המקצוע הטובים המקובלים בענף.
{{location}}
נדרש: לבצע תיקוני טיח וצבע סביב השקעים/מתגים שסביבם התקלפויות צבע או חורים בטיח ולבסוף לנקות שאריות טיח וצבע מכלל השקעים/מתגים. בנוסף, יש לעגן את השקעים באופן אחיד.

## שקעים ומפסקים חשמליים אינם מחוזקים לקירות / розетки и выключатели плохо закреплены

ליקוי: שקעים ומפסקים חשמליים אינם מחוזקים היטב לקירות, דבר שעלול לגרום לחוסר יציבות, סכנת התנתקות וליקויי בטיחות.
הליקוי אסור ע"פ תקנות החשמל (מעגלים סופיים הניזונים במתח עד 1000 וולט) סעיף ,5
ציטוט: ציוד חשמלי של מעגל סופי יותקן באופן שקביעתו לא תתרופף תוך שימוש תקין בו והוא יתוחזק במצב תקין.
נדרש: לחזק את השקעים והמפסקים באופן תקני ולוודא שהם מותקנים בצורה יציבה ובטוחה.

## הבית טרם חובר למערכת החשמל / нет электричества в кв

הערה:  בעת הבדיקה הבית טרם חובר למערכת החשמל, לכן לא נבדקה תקינות התריס החשמלי בדירה.
נדרש: יש לחבר את הדירה למערכת החשמל, לאחר חיבור החשמל בדירה יהיה ניתן לבדוק שהתריס החשמלי מתפקד בצורה תקינה.


## לא זוהה שקע - שקע חסרה /  отсутствует розетка

ליקוי: לא זוהה שקע (בית תקע) חשמלי.
{{location}}
נדרש: להתקין שקע חשמלי כנ"ל.

## אריחים פגומים / битая плитка

ליקוי: קיימים פגמים באריחי הריצוף קרמיקה, כגון: כתמים, שברים, סדקים ומקצועות שבורים העולים מעל המותר בתקן.
יש לציין מדובר בטיפוס פגמים הנראים לעין גם במבט ממרחק 1 מ' בתאורת אור יום (300 לוקס), והחורגים מהפגמים המותרים על פי טבלה 1 בת"י 314.

מצ"ב ציטוט סעיף 5.1.4.2 מת"י 1555.3 הדן ב – "ריצוף באריחי קרמיקה"

מצ"ב ציטוט סעיף 5.3.1 מת"י 1555.2 הדן ב – "הדבקת אריחים קרמיקה בקירות פנים"

{{location}}
הערה: במידה ויתברר כי לא קיימים אריחים רזרביים להחלפה, יהיה צורך בהחלפה כללית של אריחים מסוג זה. (ללא עלות בשלב זה).
נדרש:


 	להחליף את האריחים הפגומים באריחי קרמיקה חדשים.
 	פעולת החלפת אריחים עשויה לגרור עבודות גמר משלימות בעת הצורך. לדוגמא: תיקוני טיח וצבע ו/או פירוק והרכבה וחוזרת של מוצרי אלומיניום ו/או עבודות נגרות ו/או עבודות אחרות, הכל לפי עניין.כפיתרון פרגמטי לגישור על פני הליקוי לצורך הימנעות מהחלפת האריחים כדי לשמר אותם למקרים יותר חיוניים בכפוף להסכמת בעלי הנכס ובהתאם לנסיבות העניין ניתן לשקול לבצע תיקון "דנטאלי" (נקודתי) על-ידי ערכת תיקון פגמים בקרמיקה בצורה אסתטית.


## ריצוף חלול / пустота под плиткой

ליקוי: קיים חשד לחללים באריחים/ריצוף.בבדיקת הקשה שבוצעה על מנת לקבל אינדיקציה ראשונית -נשמע קול חלול. יוער כי התקן אינו מכיר בבדיקת הקשה כבדיקה תיקנית.
בזמן ביקורי במקום לא ניתן היה לבצע בדיקה של חוזק הדבקות במתיחה וזאת בכדי שלא לגרום נזק נוסף לחיפוי.
נדרש: יש לבצע בדיקת חוזק הדבקות במתיחה של מערכת החיפוי באזורים הנקובים לעיל ע"י מעבדה מאושרת.
עלות: רק לאחר קבלת תוצאות הבדיקה יתבררו עליות התיקונים.



## כתמים בריצוף / пятна, грязь на плитке

ליקוי: כתמים בריצוף.
נדרש:  להסיר הכתמים עד לקבלת מראה אחיד ובמידה ולא ניתן להסיר יש לפרק ולהחליף האריחים הפגומים.
זאת בניגוד לת"י 314 .
וכן בניגוד לת"י 1555 חלק 3 סעיף 2.5האומר שנדרש להגן על הרצפה מפני נזקים או לכלוך בעת עבודות בניה.
וע"פ נספח א' לתקן, האומר שנדרש להגן על הרצפה משאריות צמנט, חול ומלט ומכל חומר שיכול לגרום כתמים ושחיקה
{{location}}

## לא בוצע ניקיון לרצפה לצורך מסירת הדירה (לכלוך ברצפה) / грязь на полу (не вополнен никайон для сдачи кв)

ליקוי: לא בוצע ניקיון לרצפה לצורך מסירת הדירה באופן ראוי לשימוש, וזאת כנדרש עפ"י תקן ישראלי ת"י 1555 חלק 3 (2003) סעיף 5.1.5.2 ציטוט:

הערה: עקב כמות הלכלוך ע"ג הריצוף לא ניתן לאבחן פגמים בריצוף או שניתן לאבחן פגמים באופן חלקי בלבד. רק לאחר הניקיון ניתן יהיה לבדוק את תקינות אריחי הריצוף.
נדרש: להסיר את שיירי הלכלוך מפני הריצוף על פי הוראות המפורטות בנספח א' בת"י 1555.3 המצוטט להלן:


## אריחי קרמיקה (בקיר)  בגוונים שונים / Керамика на стене разного цвета

ליקוי: חיפוי הקירות בוצע באריחים קרמים מסדרות ייצור שונות, כתוצאה מכך קיימים הבדלי גוונים בין אריחי חיפוי סמוכים.
הבדלי גוון בין אריחים אסורים גם עפ"י תקן ישראלי ת"י 314 (אריחי קרמיקה לחיפוי קירות ולריצוף) סעיף 3.2
ציטוט: לא יהיו הבדלים מהותיים בין גוני האריחים ומרקמיהם.
כמו כן, העבודות בוצעו שלא ע"פ כללי מקצוע מקובלים, אשר באים לידי ביטוי במפרט הכללי לעבודות בנייה
סעיף 10031 ,ציטוט:
אריחי הקרמיקה יהיו בעלי גוון ומרקם אחידים.
נדרש: להחליף אריחים בגוון שונה לאריחים התואמים.
עלות: ללא עלות כרגע.

## סימני מלח ברובה (רטיבות) / ративут (мелах)  между робой.  итур по сантех + бдикат лехут

ליקוי: קיימים סימני תפרחת על גבי הרובה בין אריחי הריצוף, המעידים לרוב על לחות כלואה במצע שמתחת לריצוף. מצב זה מנוגד להנחיות ת"י 1555 פרק 3 (2003), סעיף 2.1.4.
נדרש:
1. לבצע בדיקת לחות למצע הריצוף.
בהתאם לתוצאות – לייבש או להחליף את המצע בכל אזור שבו הלחות גבוהה מהמותר (6% לחול, 3% לסומסום).
2. להזמין מומחה לאיתור נזילות לאבחון מקור הרטיבות.
מחיר: בדיקת לחות כ־1200 ש"ח, עלות ייבוש או החלפה בהתאם להיקף – כ־120 ש"ח למ"ר. איתור נזילה כ־1,500–1,800 ש"ח.
רק לאחר השלמת בדיקות אלו יתבררו עלויות התיקונים.

## ניקיון לבדוק שריטות / Грязное маакэ/окна, нет возможности проверить царапины

ליקוי: על פני הזכוכית נמצאו אבק ולכלוך. הדבר לא אפשר בדיקת זכוכית וויטרינה ו/או חלונות בגין שריטות או ש"ע.
יש לבצע ניקיון יסודי (לנקות חלונות, וויטרינה, זכוכית במרפסת) ולבדוק האם קיימות שריטות.
מיקום: כלל שמשות הזכוכית בוויטרינה, חלונות ומעקה במרפסת.
נדרש:
1. לנקות היטב את הזכוכית במקומות המפורטים ולבצע בדיקה חוזרת.
2. במידת הצורך לבצע תיקונים בהתאם לבעיה שתתגלה.
עלות: בשלב זה ללא עלות

## איטום סביב החלון / Итум вокруг окна (наружка)

ליקוי: איטום לקוי סביב חלון האלומיניום, מה שעלול לגרום לחדירת מי גשם, בניגוד לת"י 4068 חלק 1 סעיפים 4.1 ו-5.2.
נדרש: לבצע מילוי ואיטום במרק אלסטי מתאים סביב החלונות כדי למנוע חדירת מים ולהבטיח עמידות לאורך זמן.

## לא הורכבו פקקי פלסטיק / На рукоятке витрины: нет пробки пластика вверху

ליקוי: חסרים פקקי פלסטיק על קצוות ידיות של הכנפיים, וזאת בניגוד ת"י 1068 חלק 1 סעיף 201
נדרש: התקנת פקקי פלסטיק מתאימים בקצוות הידיות לשם השלמת המראה ושמירה על בטיחות השימוש.



## לא הורכבו מייצבי כנפיים / Не установлен "ограничитель" в месиле

ליקוי: לא הורכבו מייצבי כנפיים. זאת בניגוד ת"י 1068 חלק 1 סעיף 201
נדרש: להשלים.


## לא הורכבו מכסי בורג / Не установлен михсэ борега на витрине

ליקוי:  לא הורכב מכסי בורג בדופן כנפי דלתות הזזה (וויטרינה). מדובר בפלסטיק שמטרה שלו למנוע חדירת רוח דרך החריצים בין הכנפיים למסילות. זאת בניגוד ת"י 1068 חלק 1 סעיף 201
מיקום: במקומות פזורים בכנפי חלונות וויטרינה בדירה.
נדרש: להשלים הרכבת מכסים חסרים.
דוגמא למכסה בורג:


## לא הורכבו סטופרים בוויטרינה / нет стопера (для зазора крыльев) витрины

ליקוי: לא הותקנו מעצורים לכנפיים של הוויטרינה, דבר העלול לגרום לפגיעה במסגרת האלומיניום ולסיכון המשתמשים מפגיעות באצבעות, בניגוד לת"י 1068 חלק 1 סעיף 201.
נדרש: להתקין מעצורים תקניים לכנפיים כדי למנוע פגיעות ולשמור על שלמות המסגרת.



## פינה חדה / Острый угол керамика (туалет)

ליקוי: קיימת פינה חדה  וחותכת המהווה סכנה בטיחותית.
נדרש: יש להתקין פינות מעוגלות (קטמות) כדוגמת המתואר בצילום המחשה שלהלן.


## חלון קיף נפתח 90 מעלות / халон кип открывается больше чем на 90 гр

ליקוי: חלון קיפ נפתח 90 מעלות ומסכן את המשתמשים בשירותים,וזאת בניגוד להוראות ת"' 1068.1.
{{location}}
נדרש: להחליף את הפרזול, להגבלת פתיחה 60 מעלות או להתקין מעצר פתיחה.


## ממ"ד: חלון הדף תקוע / Окно битахон  мамадазастряло

ליקוי: חלון הדף תקוע, בנוגד לתקן תקן 4422 חלק 2 סעיף 4.2.
נדרש: יש לתקן את החלון עד סגירה מלאה והרמטית.




## חלון לא נסגר / окно/витрина не закрывается

ליקוי: הכנף החלון ו/או וויטרינה לא ננעלת בצורה תקינה, וזאת בניגוד להוראות תקן 1068.1.
מצ"ב ציטוט סעיף 201 מת"י 1068.1 הדן ב – " חלונות: דרישות כלליות ושיטות בדיקה"

{{location}}
נדרש: לבצע כיווני/חיזוק ואו החלפת נעילה בחלון/וויטרינה.

## חסר אף מים בקופינג/  нет аф маима в копинге

ליקוי: חסר אף מים (שם מדלף) בקצה לוחות הקופינג,וזאת בניגוד לדרישות ת"י 1414.3 ות"י 1920.2. וכללי מקצוע המקובלים בענף.
יש לציין כי בחלק אבני הקופינג אין אפשרות לבצע חריץ כאבן צרה מדי ולא בולטת ממישור הקיר.
מצ"ב ציטוט סעיף 4.7.1 מת"י 1920.2 הדן ב- "מערכת הטיח באתר".


מצ"ב ציור א5 מת"י 1414.3 הדן ב- "השמת טיח תרמי חיצוני"

נדרש:
1. יש לבצע חריץ אף בתחתית שולי הקופינג, כפתרון פרגמאטי כדי להימנע מהחלפת האבן אשר לא מאפשרת ביצוע חריץ (אינה בולטת מספיק מקו הקיר) והתקנת אבן רחבה יותר בעלת חריץ אף מים.
2. יש לבצע תיקוני טיח וצבע גמיש עמיד בתנאי חוץ.

## אפי מים סתומים / Аф маим забит под окном

ליקוי: אפי מים סתומים בתחתית אדני אבן החלון/ות.
{{location}}
נדרש: לחרוץ את אפי המים הסתומים.
זאת בניגוד למפרט הכללי - סעיף 100512 - לפיו נדרש כי "אדני חלונות, כרכובים, מעקות וכו', יעובדו לרבות שיני מדלף (אף מים)".ובניגוד למפרט הכללי - סעיף 10074 - לפיו נדרש כי "שפת
האדן המובלטת מהקיר משלושת העברים תעובד עם שן מדלף".

## תריס החשמל לא עובד / Трис хашмали не работает

ליקוי: תריס החשמל אינו מתפקד.
נדרש: לתקן את התריס ולהביאו למצב שימוש תקין.

## פגמים (שריטות) בתריס / вмятина/царапина на трисах

ליקוי: שלב/י תריס פגום/מים, וזאת בניגוד להוראות תקן 1509.1.
נדרש: החלפת שלב/י תריס.

&nbsp;

## תריס מחדיר אור / трис пропускает свет

ליקוי: בעת סגירה מלאה של התריסים יש עדין חדירה של אור מחוץ המבנה.
נדרש ע"י ת"י 1509.2  שבסגירת רפפות התריס לא יהיו חריצי אור.
נדרש: יש לכוון את התריס עד לסגירה מלאה והרמטית למניעת חדירת אור ואוויר למבנה.


## כיווני נעילה ומתיחה של רצועות גלילה / натяжка ремней трисов

ליקוי: תריס הגלילה לא מתפקד בצורה ראויה, וזאת בניגוד להוראות תקן 4068.1.
נדרש: יש לבצע מתיחה של רצועות הגלילה, כיוונים והתאמות נדרשים.




## חלון הדף קצר מידי / Окно мамада короткое

ליקוי: חלון הדף קצר מידי.
{{location}}
נדרש: החלפת חלון הדף.

## סדקים בטיח / трещины в тиахе

ליקוי: קיימים סדקים בטיח.
הליקויים הנ"ל בניגוד ל: תקן ישראלי ת"י 1920 חלק 2 – טיח: מערכת הטיח באתר, סעיף 3.1 לפיו מראה, גימור וגוון הטיח יתאימו למוזמן. במידה ומערכת טיח מיועדת לגימור על–ידי שכבת צבע, לא יהיו סדקים בעובי העולה על 0.3 מ"מ.
נדרש:
1. פתיחת הסדקים באמצעות כלי מתאים.
2. מילוי הסדקים בחומר איטום מתאים ושכבת שפכטל.
3. שיוף וצביעה בגוון תואם לקיר.
הערה: במידה בסדק יחזור יש לפנות למהנדס קונסטרוקטור על מנת לבחון את הסיבה לסדיקה.

## רטיבות / пятна ративута (найти и починить)

ליקוי: אותרו סימני רטיבות המלווים בהתקלפות והתנפחות של שכבת הטיח והצבע.
נדרש: להזמין מאתר נזילות מקצועי לאיתור מקור הרטיבות, ולאחר מכן לבצע את התיקונים הנדרשים בהתאם לממצאים.
הערה: עלות התיקון תיקבע בהתאם למורכבות הבעיה והיקף העבודה שיידרש.
תקן/כללי מקצוע
הליקוי יוצר פגם אסתטי ותפקודי בולט וסותר בין היתר את הדרישות
כמפורט להלן: תקנות התכנון והבנייה סעיף 32.5 הדורש כי: "קירותיו החיצוניים של בנין יתוכננו וייבנו באופן המונע חדירת מים ורטיבות לתוכו מבחוץ.".

## גבשושיות וגלים/Неровности и наплывы на стене

ליקוי: בטיח הדירה בקטעים מפוזרים נמצאו גבשושיות וגלים.
{{location}}
נדרש: לבצע חידוש חלקי תוך יישור בסרגלים, וצביעה חוזרת .
זאת בניגוד לתקנים הישראלים של מכון התקנים ת"י 1920.2– לגבי סטיות מותרות בטיח.
ובניגוד למפרט הכללי סעיף 09.04.01.01 לפיו: "יום לפני התחלת עבודות הטיח יבצע הקבלן את הפעולות הבאות: א. יסתום את החורים והמרווחים ("פוגות") בין הבלוקים, יסיר שכבות רופפות ויקצץ חוטי קשירה… ב. ינקה את פני השטח משמן, אבק, מלחים וכד'…" וכן בניגוד לסעיף 09.09.

## טיח מתקלף

ליקוי: טיח וצבע מתקלפים.
{{location}}
נדרש להסיר טיח פגום,לבצע מחדש בצורה מקצועית תוך שימוש בערבים וכן לחדש צביעה .
זאת בניגוד לת"י 1920.2 סעיף 3.1 המחייב שמראה הטיח, גימורו וגוונו יתאימו למוזמן.
זאת בניגוד לת"י 1922 חלק 1 הדורש שהצבע יתאים לדרישות התפקוד בהתאם לתנאי הסביבה.

## דלת ממ"ד אין סימון / нет значка текена на двери мамада

ליקוי: הדלת של הממ"ד איננה מסומן בתווית היצרן, וזאת בניגוד להוראות ת"י 4422.2.
היעד סימון יוצר מצב של אי וודאות בנושא תקניות הדלת.מצ"ב ציטוט סעיף 2.2.2 מת"י 4422.2
הדן ב – "דרישות ובדיקות ופרטי מסגרות במרחבים מוגנים

נדרש:
א. לספק אסמכתאות בעניין תקניות הדלת.
ב. החלפת הדלת, במידה ויתברר כי הדלת איננה תקינה. (לא מחיר בשלב זה)

## קילופים ופגיעות בדלת ממ"ד / удары/царапины на двери мамада

ליקוי: קילופים ופגיעות בדלת הממ"ד, בניגוד לתקן הישראלי ת"י 23, האוסר על פגיעות מסוג זה בדלת ממ"ד.
נדרש:
- תיקון הקילופים והפגיעות בדלת באמצעות ליטוש.
- צביעה מחדש בצבע עמיד ואיכותי, בהתאם לדרישות התקן.
הערה: במידה והפגיעות חמורות, יש לשקול החלפת הדלת לדלת תקנית חדשה.
החלפה (במידת הצורך): 2500-4000 ש"ח.

## ידית דלת ממ"ד עקומה / ручка двери мамада кривая

ליקוי: הידית בדלת הממ"ד אינה יציבה ומתנדנדת.
{{location}}
נדרש: לחזק את התקנת הידית בדלת הממ"ד.

## חלון ממ"ד אין סימון / Окно мамада нет значка (симун)

ליקוי: החלון אינו מסומן כנדרש עפ"י לת י " 4422 חלק 2 (פריטי מסגרות למקלטים: פריטים למרחבים מוגנים-דרישות ובדיקות , ) סעיף 2.2.2 הפנייה לתקן זה מתקנות הג א" , סעיף 206 (ג)


## חלון ממ"ד אינו צבוע טוב / Окно мамада  плохо покрашено

ליקוי: כנף חלון ממ"ד אינו צבוע כהלכה, זאת בניגוד לת"י 4422 חלק 3.

{{location}}
נדרש: לצבוע מחדש

## פין הנעילה בחלון ממ"ד תקוע / Замок застрял в окне мамада

ליקוי: פין הנעילה של כנף הפלדה תקוע.
נדרש: לשחרר את הפין נעילה עד לתפקודו בצורה תקינה.

## בחלון הממ"ד לא הורכב תריס

ליקוי: בחלון הממ"ד לא הורכב תריס.
{{location}}
נדרש: להתקין תריס בחלון ממ"ד בהתאם למפרט.

## ממ"ד: מעבר הצנרת מיזוג אוויר אינו תקין / Неправильно проложен трубопровод кондиционера

ליקוי: התקנת המזגן בוצע באופן בלתי תקני. מעבר הצנרת מיזוג אוויר איננו אטום מפני גאזים.
{{location}}
נדרש: לאטום את המעבר צנרת ע"י אביזר אטימה תקני.

## מערכת סינון לא הותקנה / В мамаде не установлена маарехет синун (фильтр мамада)

ליקוי: טרם הושלמה התקנת מערכת סינון ביתית (תיבת נח)

## חסרה שקע T.V בממ"ד / нет тв точки в мамаде

ליקוי:  לא אותר שקע T.V בממ"ד. עפ"י הוראות פיקוד העורף צריך להתקין שקע לטלוויזיה בחדר ממ"ד.
נדרש: להתקין שקע T.V בממ"ד.


## שיפוע לקוי במרפסת לפחות 1% / уклон плохой в балконе. Должен быть минимум 1%

ליקוי: נמצא שהריצוף ללא שיפוע של לפחות 1%, כאשר בפועל בוצע ____%.
זאת שלא בהתאם לנדרש בתקן ישראלי ת''י 1555 חלק 3 סעיף 3.2 ,ציטוט:
{{location}}
נדרש: לרצף מחדש עם שיפוע מינימלי של 1%

וכן עפ"י סעיף 5.1.4.3 שבתקן 1555.3 ,ציטוט:



## איטום מרפסת חיבור קיר/רצפה / роба балкона кир/рицпа

ליקוי: מילוי מישקי ההפרדה בין אריחי הריצוף לקירות (פנלים/חיפוי) במרפסת בוצע בצורה לקויה, תוך שימוש בחומר שאינו גמיש.
נדרש: להסיר את המילוי הקיים ולבצע מילוי מחדש באמצעות חומר גמיש ועמיד המתאים לשימוש חיצוני.
הליקוי אסור ע''פ תקן ישראלי ת''י 1555 חלק 3 סעיף 4.7.4 ,ציטוט:

מצ"ב צילום להמחשת הליקוי (צולם בנכס אחר)


## מעקה בטיחות בגובה פחות מ105 ס"מ / Маакэ балкона ниже 105 см

ליקוי: גובה מעקה בטיחות בוצע לא לפי תקן 1142, בפועל גובה הינה ___ ס”מ, מדובר בליקוי בטיחותי הנוגד את הוראות ת”י 1142 עלפיו על גובה המעקה להיות לפחות 105 ס”מ מפני בליטה העולה על 4.5 הנחשבת כאלמנט המאפשר טיפוס
{{location}}
נדרש: להגביה את המעקה עד גובה של לפחות 105 ס"מ בהתאם להוראות ת"י 1142.

## חוסר איטום בקופינג / хосер итум между копингами

ליקוי: חסר מילוי רובה במישק חיבור בין לוחות הקופינג, וזאת ניגוד להוראות תקן 2378.4.
נדרש: מילוי רובה /כוחלה.


## קופינג שבור-החלפה /  Копинг битый - демонтаж копинга/замена

ליקוי: חיפוי אבן סדוק ו/או שבור, זאת בניגוד לת"י 2378.1 סעיף 3.2.1 הדורש שהאבן צריכה להיות שלמה ללא סדקים או פגמים אחרים העלולים להשפיע על החוזק והמראה שלה.
נדרש: החלפת חיפוי אבן בכפוף להוראות  תקן 2378.1 או לבצע תיקוני דבק שיש במידת הניתן. (ניתן לעשות תיקונים קלים אם אושרו מבחינה הנדסית).



## חוסר כוחלה בקיר חיצוני / нет кохлы между камнями на стене

ליקוי: באבני חיפוי חוץ חסר ו/או מילוי לא אחיד של כוחלה (מילוי מישקים).
חוסר במילוי מהווה הן ליקוי באטימת מערכת החיפוי והן פגם אסתטי ומנוגד למפכ"מ 378 , סעיף 105.3.
ומנוגד לת"י 2378.1 לחפוי באבן טבעית, סעיף 5.3.2 ו- 5.3.3 :
נדרש: לבצע תיקוני כוחלה ומילוי משיקים באבני חיפוי החוץ.

## כתמים ולכלוך בקיר חיצוני / пятна/грязь на кир хицоне

ליקוי: ישנם כתמים ולכלוכים בקיר חיצוני אשר מקורם בעבודות הבנייה שהתבצעו בשטח.
נדרש: לבצע עבודות ניקוי יסודי  להחזרת המראה האסתטי.

## איטום בין האמבטיה לקיר (רובה צמנטית) / Итум амбатии роба цементная

ליקוי: במישק המחבר בין אמבטיה לקיר בוצע איטום ע"י רובה צמנטית במקום רובה גמישה.
{{location}}
נדרש: להסיר את המילוי הקיים ולבצע מילוי בשנית ע"י חומר גמיש.

## איטום (רובה) קיר/רצפה кир-рицпа  роба

ליקוי: בחיבור בין הרצפה לקיר בחדר הרחצה לא בוצע איטום בחומר אלסטומרי, דבר שעלול לגרום לחדירת מים ולנזקים בריצוף ובקירות.
נדרש: להסיר את החומר הקיים (אם יש) ולבצע איטום בחומר אלסטומרי גמיש, בהתאם לתקן ישראלי ת"י 1555 חלק 3.
להלן ציטוט מת"י 1555.3


## איטום (רובה) קיר/קיר кир-кир роба

ליקוי: מילוי משקי ההתפשטות בוצע בחומר שאינו גמיש (אלסטומרי).
משקי התפשטות הם מרווחים בין האריחים שמאפשרים להם לזוז כאשר יש שינויי טמפרטורה או לחות, כדי למנוע סדקים. את המרווחים הללו ממלאים בחומר גמיש שמאפשר תזוזה טבעית של החומרים.
נדרש: להסיר את הרובה ממשקי ההתפשטות ולהשלים את האיטום בחומר גמיש, בהתאם להנחיות תקן 1555 חלק 2, סעיף 4.7.
דוגמאות למשקי ההתפשטות מתוארים בשרטוט המצורף .
מצ"ב ציטוט סעיף 4.7.2 + ציורים 2 ו - 5
מת"י 1555.2 הדן ב – "הדבקת אריחי קרמיקה בקירות פנים"


## ליקויי איטום באזור / Ликуй итум вокруг

ליקוי: ליקויי איטום באזור _________
הליקוי הנ"ל בניגוד ל:
תקן 1205, חלק 3 – סעיף 2.1 לפיו: "מקום המגע בין קביעת שרברבות לבין סביבתה (קיר, רצפה, משטח עבודה, ריהוט) יהיה אטום מים.
{{location}}
נדרש: לבצע איטום בסיליקון במקומות הנ"ל.

## ברז  רופף / кран шатается

ליקוי: ברז המים אינו יציב ומתנדנד, מה שעלול לגרום לנזילות ולבלאי מואץ.
נדרש: חיזוק וקיבוע הברז למקומו בצורה יציבה, ובדיקת תקינות החיבורים למניעת נזילות.

## אסלה רופפת / Туалета (асла) шатается

ליקוי: אסלה רופפת.
נדרש: לחזק את חיבורי האסלה לרצפה ולוודא שהיא מקובעת בצורה יציבה. במידת הצורך, להחליף את הברגים או לבצע איטום מחדש.

## סיפון הכיור לא תקני / Сифон киёра шаршури ликуй

ליקוי: סיפון הכיור לא תקני, התקנה היא לא תקנית ועלולה לגרום לסתימות וחדירות ריחות וחרקים לדירה.
נדרש: להחליף סיפון בכיור לתקני.

## מקלחת שיפוע

ליקוי: ריצוף המקלחת בוצע ללא שיפועים מתאימים לכיוון הנקז, נמדד שיפוע ___ .
מצ"ב ציטוט סעיף 3.2.5.1 מת"י 1205.3 הדן ב – " התקנת קבועות שרברבות"

נדרש: הסרת הריצוף וריצוף מחודש עם שיפועים לכיוון הנקז בין %1 - ל %4.

## גובה האסלה (38-42)

ליקוי: גובה האסלה ביחס לפני הריצוף אינו תקני, וזאת בניגוד לתקן 1205.3 . נמדד גובה _____  ס"מ
נדרש:  להתקין את האסלה בגובה הנדרש בת"י 1205.3 (38-42 ס"מ)

## לא הותקן מושב לאסלה.

ליקוי: לא הותקן מושב לאסלה.
{{location}}
נדרש: יש להתקין מושב אסלה.

## לא אותרה גומייה במכסה קופסת ביקורת / Нет гумии в куфсат бикорете

ליקוי: לא אותרה גומייה במכסה קופסת ביקורת.
{{location}}
נדרש: להתקין גומייה במכסה קופסת ביקורת.

## מרכזית המים ללא איטום ברצפה

ליקוי: מרכזית המים (ארון מחלקים) ללא עיבוד גמר איטום ברצפה וכן בהיקף הארון.
{{location}}
נדרש: יש לבצע גמר איטום ברצפת ארון המחלקים לרבות איטום בהיקף הארון.

## חומרי בנייה בתוך הקו

ליקוי:  אותרו חומרי בנייה בתוך הקו. במצב הקיים זרימת המים תהיה לקויה ויתכנו הצפות.
נדרש: לבצע שטיפת קו ביוב.

## לחצן אסלה רופף.

ליקוי: לחצן אסלה רופף.
{{location}}
נדרש:  להתקין מחדש.

## ראש דוש רופף

ליקוי: ראש דוש אינו מקובע בצורה מקצועית.
נדרש: לקבע את ראש המקלחת אל הקיר בצורה יציבה ואסתטית, תוך שימוש באמצעי קיבוע מתאימים להבטחת יציבות ועמידות לאורך זמן.

## רוחב מקלחת קטן (פחות ב 70 ס"מ)

ליקוי: רוחב המקלחת  הינו ___ ס"מ, בניגוד ל-הל"ת סעיף 3.11.3 הקובע שהרוחב לא יפחת מ 70- ס"מ.
{{location}}
נדרש:
א. לפרק את הריצוף ולבצע תא רחצה מורחב לגודל של 0.65 מ"ר לפחות.
ב. להקפיד על שמירת שיפוע ניקוז תקני (1%-4%) כקבוע בת"י 1205.3.
ג. רצוי לבצע הנמכה מדורגת כמומלץ בהל"ת.
הערה: במידה ולא ניתן להרחיב את תא המקלחת, יהיה צורך לקבוע ירידת ערך
לנכס אשר ע"י שמאי מקרקעין.


## חסרה רשת  בניקוז מסתור כביסה/ Решет никуза мистор квисы отсутствует

ליקוי:  לא הורכבה רשת ניקוז לפתח ניקוז מסתור כביסה, וזאת בניגוד להל"ת. הליקוי עלול לגרום לחדירת לכלוך ולסתימת צינור הניקוז.
נדרש: לנקות את הניקוז כדי לשלול סתימה וחדירה של לכלולך לתוך מערכת הניקוז שעלולים לגרום לסתימה בעתיד, ולהרכיב רשת ניקוז.
&nbsp;


## ניקוז סתום במסתור כביסה / Никуз мистор квисы забит

ליקוי: קולט ניקוז סתום במסתור כביסה.
{{location}}
נדרש: לשחרר סתימה במסתור כביסה.

## רצפת המסתור ללא גמר טיח וצבע + שיירי בניה / На полу мистор квиса нет финиша+хомрей бния

ליקוי: רצפת המסתור ללא גמר טיח וצבע בחיבור היריעות לקיר ומלאה שיירי בניה.
{{location}}
נדרש: לבצע גמר טיח וצבע לרבות ניקיון רצפת מסתור הכביסה.

## חסר מתקן לתליית כביסה / Нет крепежа для сушилки белья

ליקוי: חסר מתקן לתליית כביסה.
{{location}}
נדרש: להתקין מתקן + חבלי כביסה

## שיפוע  לקוי מסתור כביסה / Плохой уклон м.квисы

ליקוי: שיפועה לקויי רצפת מסתור כביסה, השיפוע הקיים אינו מסודר לעבר נק' הניקוז.
{{location}}
נדרש: לתקן ע"י יציקת מדה חדשה לכיוון נק' הניקוז.

## סדקים במדה (רצפת מסתור כביסה) / Трещины на полу м.квисы

ליקוי: ישנם סדקים בשכבת המדה הקיימת .
{{location}}
נדרש: לבצע אטימה חוזרת.

## גמר לקוי באזור מעבר צנרת ביוב / Плохой финиш в районе прохода трубы

ליקוי: גמר לקוי באזור מעבר צנרת ביוב.
{{location}}
נדרש: לבצע גמר סביב לצינורות.

## צנרת הורטיקאלית של מסתור הכביסה חודרת ללא שרוולי מעבר תקניים / Вертикальные трубы в мистор квисе проходят бещ шарвуля через потолок

ליקוי: צנרת הורטיקאלית של מסתור הכביסה חודרת ללא שרוולי מעבר תקניים.
{{location}}
נדרש: לסתת את בנייה סביב הצינור ולבצע שרוול תקני לחדירת הצנרת.
להלן ציטוט מת"י 1205.0 - חובת שרוולים למעבר צנרת.


## אריחים בולטים/שקועים / плитка просадка/выступает

ליקוי: אריחים בולטים/שקועים מכלל המשטח, כתוצאה ממחסור במלט ו/או עבודה לקויה, וזאת בניגוד לתקן 1555 חלק 3, נספח ב’, הקובע כי הפרש גובה בין אריחים סמוכים לא יעלה על 1.5 מ“מ כאשר רוחב המישק הוא בין 3 ל-5 מ“מ.
נדרש: לפרק את האריחים ולבצע מחדש את ההתקנה בצורה אחידה וללא סטייה מהמישור.

## פגמים באמבטיה/Битая ванна

ליקוי: אותרו פגמים באמבטיה,
נדרש: לפרק ולהחליף את האמבט, לחלופין ניתן  לנסות לבצע תיקון ע"י צבע אמייל קר עם אחריות לתקופה הנדרשת בחוק מכר דירות (3 שנים לפחות).
זאת בניגוד לתקן 23 - לפיו נדרש לשמור על האמבט מפני נזקי הובלה, אחסנה והתקנה ע"י המוכר, הקבלן ומי שמתקין את האמבט וכן אסור שיהיו באמבט פגמים שיפגעו בשימוש או בקיימותו ראה טבלה 3
וכן בנגוד לתקן 1205 חלק 3 ומפרט 418


## לא הותקן פעמון / не установлен дверной звонок

ליקוי: טרם הותקן פעמון בדירה.
נדרש: להתקין פעמון דלת.

## חסר מחסה ללוח חשמל/תקשורת  / нет крышки эл.считка/тикшорета

ליקוי:: חסר מכסה ללוח חשמל/תקשורת
נדרש: להשלים.

## טרם הותקן אינטרקום  /  не установлен интерком

ליקוי: טרם הותקן אינטרקום.
נדרש:  יש לספק ולהתקין אינטרקום.

## מכסה לא נסגר טוב בגלל  קיר עקום / крышка не закрывается из за того что стена кривая

ליקוי: מכסה לא נסגר היטב בגלל התעקמות המסגרת עקב קיר עקום.
נדרש : יש לפרק את המסגרת, ליישר את הקיר ולהתקין מסגרת מחדש בצורה תקינה .

## רעש בתריס / шум при закрытии трисов

ליקוי: קיימים רעשים בעליית/ירידת התריסים.
זאת בניגוד לת"י 4068 חלק 1 סעיף 4.1 ששם נדרש שתפעול המוצר יהיה תקין.

נדרש: לתקן את מנגנון ההפעלה.

## קיימים רעשים בעליית/ירידת התריסים / Шумы во времяопуска трисов окна,витрины

ליקוי: רעשים קיימים בעת העלאה או הורדה של התריסים, בניגוד לת"י 4068 חלק 1 סעיף 4.1.
נדרש:
- לבדוק את מערכת התריסים, כולל המנגנון, המסילות והחיבורים.
- לשמן את החלקים הנעים.
- במידת הצורך, להחליף רכיבים פגומים כמו מנוע, גלגלים או מסילות.


## מלבן חלון עקום / Мисгерет окна кривая

ליקוי: מלבן חלון עקום
נדרש: פירוק מלבן עקום, התקנת חלון מחדש.


## מסילה עקומה (פגמים באלומיניום) / Кривая месила/битая

ליקוי:: באביזרי האלומיניום קיימים פגמים בולטים לעין מסוג מעיכות ושריטות ו/או פגמים.
נדרש: להחליף את החלקים הפגומים.
נוגד לתקן 4068 , חלק 1 , סעיף 4.1 , ציטוט:

הליקוי מנוגד לקבוע בת"י 4402, חלק 2 , ציטוט:


בבדיקה חזותית של המשטחים העיקריים של הפרופיל לא יהיו פגמים בציפוי, לא יהיו מקומות לא מצופים, כתמים, נקודות, סדקים וכדומה. הפרופיל יהיה נקי ולא יהיו בו סימנים של נזק כלשהו.


## מעקה בטיחות לא מקובע ורופף (יציב) / Маакэ шатается (плохо закреплено)

ליקוי: בבדיקה ידנית ע"י הפעלת כוח בכיוון אופקי ע"ג המעקים התגלה כי המעקה מורכב באופן רעועה.
נדרש: בדיקה ו/או חיזוק המעקה בכפוף להוראות ת"י 1142.

## אריחי אבן בחיפוי קירות בולטים-שוקעים / Плитка на стене выступает-просаживается

ליקוי: באזור/ים המתואר/ים בצילומים שלהלן, זוהו לוח/ות חיפוי אבן הבולט/ים ו/או שוקעים באופן החורג מהסטייה המותרת על פי תקן 2378.5 (1.5 מ"מ).
נדרש:
1. החלפת לוח אבן והרכבתה בקו אחיד אם פני מישור חיפוי הקיר.
2. במידה ויוחלט בהסכמה בין הצדדים כי תיקון הליקוי בלתי מעשי/כדאי אזי יש לפצות את המזמין בגובה עלות התיקון.

## איטום  סביב  לוויטרינה / итум вокруг витрины

ליקוי: חוסר איטום סביב הוויטרינה במרפסת.
נדרש:
- לבצע איטום מחדש סביב הוויטרינה באמצעות סיליקון או חומר איטום גמיש ואיכותי המותאם לשימוש חיצוני.
- לוודא שהאיטום עמיד למים ומעניק איטום מלא לאורך כל המסגרת.

## קיר עקום / кривая стена

ליקוי: קיר אינו במישור אחיד.
נדרש: יש לבצע תיקוני טיח עד קבלת מישור אחיד.

## גימור טיח וצבע במראה לא אחיד / плохая покраска, финиши

ליקוי: גימור טיח וצבע במראה לא אחיד.
ניכרים סמני מברשת/רולר בולטים, גבשושי וחוסר אחידות בגוון הצבע.
זאת בניגוד לת"י 1920 סעיף 3.1 המחייב שמראה הטיח, גימורו וגוונו יתאימו למוזמן.
נדרש:
א. לבצע שכבת צבע נוספת עד לקבלת גוון אחיד, ללא סימני גרגירים וללא סימני מברשת או רולר.
ב. להקפיד לפרק את גופי החשמל בטרם הצביעה ולהרכיבם באופן מדויק ויציב לאחר גמרה צביעה."

## צילינדר בדלת כניסה לא תקין / Дверной цилиндр не исправен

ליקוי: צילינדר בדלת כניסה לא תקין.
נדרש: להחליף.

## לא הותקן מכסה עבור עינית לדלת כניסה / нет михсэ для глазка двери

ליקוי: לא הותקן מכסה עבור עינית לדלת כניסה.
נדרש: להשלים.

## מילוי חומר גמיש במישק ההפרדה בין משקוף דלת הכניסה

ליקוי: לא בוצע מילוי חומר גמיש במישק ההפרדה בין משקוף דלת הכניסה והחיפוי.

נדרש: יש לחרוץ רובה קיימת ולבצע מילוי חומר גמיש.
&nbsp;

## מנעול בטחון שריטות בשימוש / царапина во время использования замка безопасности

ליקוי: סגר בטחון עליון הותקן בניגוד לכללי המקצוע המקובלים בענף. רכיבי הסגר מתחככים זה בזה בעת שימוש.
נדרש: פירוק והתקנה מחודשת.

## פגמים במלבן הדלת (משקוף פגום) / вмятина в машкофе двери

ליקוי: קיימים פגמים במלבן הדלת (נזק חזותי), זאת בניגוד לת"י 23 חלק 6.
נדרש: החלפת מלבן דלת.



## אסלה עקומה / Туалета (асла) кривая

ליקוי: האסלה מותקנת בצורה עקומה ואינה מיושרת כראוי.
נדרש: פירוק האסלה ויישורה מחדש, תוך חיבור יציב ותואם לתשתית הקיימת.

## סטיות ואי התאמות, חסר אורך רוחב - Не соответствие в размерах по чертежу

ליקוי: נמדד אורך/רוחב של ___ ס"מ במקום ____ ס"מ.
הובהר לרוכשים כי אינני מודד מוסמך ועל כן יתכנו סטיות במדידה זו כמו כן בוצעה מדידה לשטח נטו ללא חישוב קירות חוץ או פנים. יש לציין כי מדידה זו אינה קבילה מבחינה משפטית.
מומלץ: לבצע מדידה ע"י מודד מוסמך. באם קיימת אי התאמה מעל למותר יש לפנות לשמאי מקרקעין לצורך הערכת הפיצוי הכספי.

## דלת ממ"ד ניכר אור / При  закрытой двери мамада проходит свет

ליקוי: בזמן סגירת דלת הממ"ד ניכר מעבר אור, מה שמעיד על איטום לקוי ועלול לפגוע בתפקוד הדלת בהתאם לדרישות המיגון.
נדרש:
- לבדוק את תקינות גומיות האטימה ולתקן או להחליף אותן במידת הצורך.
- לוודא יישור נכון של הדלת והתאמתה למשקוף למניעת חדירת אור ואוויר.
&nbsp;

## דלת ממ"ד: אין סף תחתון / дверь мамада нет порога

ליקוי: דלת ממ"ד, אין סף תחתון.
נדרש: להחליף דלת.

## כיוון דלתות ארון / Соосность дверей шкафа/регулировка петель

ליקוי: חוסר התאמה והפעלה לקויה של ארונות, דבר העלול לפגוע בשימוש התקין ובאסתטיקה..
נדרש: יש לבצע כיווני סגירה ותיאום נדרשים.
הליקוי אסור ע"פ תקן ישראלי ת"י 1271 חלק 1 (ריהוט: ארונות) , סעיף 3.2.2
ציטוט: כל המרכיבים הנעים ינועו בחופשיות ויתאימו לפתחים שהם מיועדים לסגור.
ההתאמה תובטח על ידי מבנה מתאים ועל ידי מידות מתאימות. מבנה המגירות, המדפים הנשלפים, היחידות לבקבוקים ויחידות
דומות יימנע את הוצאתן ממקומן בעת השימוש, אלא אם נקבע אחרת בין המזמין ליצרן הדלתות, פרט לדלתות הזזה, יחוברו על ידי
צירים. דלתות אופקיות יישענו על אבזרים מתאימים. דלתות הזזה ומגרות ינועו על גבי מסילות.

## ארון : פגמים בציפוי/ удары/вмятины  на дверях

ליקוי: פגמים בציפוי ארונות, כולל קילופים או שחיקה במראה החיצוני.
נדרש: ללטש ולחדש את הציפוי או להחליף את האלמנטים הפגומים בהתאם לסוג הגימור.

## ארון: מדפים קצרים / Короткие полочки

ליקוי: ארונות מדפים קצרים.
נדרש: החלפת מדפים.

## ארון: רטיבות ועובש / ративут и плесень в шкафах

ליקוי: אותרו סימני רטיבות ועובש בארון.
נדרש: תיקון נזילה, החלפת אלמנטים רובים.

## צנרת שופכין גלויה

ליקוי: הותקנה צנרת שופכין לחיבור אסלה כשהיא גלויה באופן היוצר פגם אסתטי בולט לעין.
נדרש: לעטוף את הצנרת ברשת אקספנדר מגולוונת, לטייח ולחפות באריחי קרמיקה מסוג וגוון תואמים את הקיים.

## בית טרם חובר לאספקת מים/ Квартира не подключена к воде

הערה: הבית טרם חובר לאספקת מים מלאה, עקב כך אין אפשרות לבצע בדיקת אינסטלציה בנכס.

## (שוחות ביוב) בור ביוב  אינם מותאמות למפלס הגינה

ליקוי: בפיתוח המגרש נמצא, כי תאי הביקורת של ביוב החוץ אינם מותאמות למפלס הגינה.
נדרש: להתאים את תאי ביקורת למפלס הגינה.

## מילוי חסר בחצר / Хацэр добавить землю-выровнять

ליקוי: יש להשלים אדמת מילוי חסרה בחצר הדירה כולל הידוק אדמת המילוי והתאמת שוחות לגובה פני האדמה.

## אריחים רזרביים / хосер резервной плитки (2%)

ליקוי: אריחים רזרביים שנמצאו הנכס ואינם מספקים לפי הכמות הדרושה אריחים רזרביים.
על הקבלן לספק אריחים רזרביים בכמות המקובלת של %2 מכלל האריחים וזאת עפ"י תקן ישראלי ת"י 1555 חלק 3 סעיף 2.2.11 ,ציטוט:


## שריטה בחלון/ויטרינה (אלומיניום) / Царапина на окне-витрине

ליקוי: שריטות/קילוף צבע ע"ג פרופיל מוצר האלומיניום (חלון/וויטרינה/דלת),וזאת בניגוד להוראות תקן 4068.1.
נדרש: תיקון פחחות ו/או צביעה אסתטית בשיטת התזה באמצעות ספריי אירוסול בגוון התואם למניפת של הצבעים היצרן.


## אריחים פגומים בקיר חיצוני / битая плитка на кир хицони

ליקוי: אריחים פגומים בקיר חיצוני. העבודות בוצעו שלא ע"פ כללי מקצוע מקובלים, אשר באים לידי ביטוי במפרט הכללי לעבודות בנייה סעיף 10051, ציטוט:

נדרש: לפרק ולהחליף את האריחים הפגומים בהתאם לנדרש בסעיף 10051.

## צביעה לקויה -סף דלת ממ"ד - плохо покрашен порог деври мамада

ליקוי: פגמים חזותיים בסף תחתון הממ"ד, וזאת בניגוד לת"י 4422 חלק 3.
נדרש:תיקוני פחחות ו/או צביעה ע"י צבע עשיר באבץ בהתאם להוראות המפורטות בסעיף 3.2.3 בתקן 4422.3.


&nbsp;

## חלון הממ"ד נפתחת לכיוון אחר/ Окно мамада открывается в другом направлении

ליקוי: אגף חלון הממ"ד נפתחת לכיוון ___ במקום לכיוון ____, וזאת בניגוד לתכנית.
נדרש: להפוך כיוון פתיחת אגף.

## איטום בין האמבטיה לקיר (חוסר איטום) / Итум амбатия кир хасэр

ליקוי: במישק המחבר בין אמבטיה לקיר לא בוצע איטום ע"י רובה גמישה.
נדרש: לבצע מילוי ע"י חומר גמיש.

## פינה חדה (חלון) / Острый угол (окна)

ליקוי: קיימת פינה חדה וחותכת.
נדרש: להתקין מגן פינות חדות.

## במלבני העץ של דלתות הפנים ישנם פגמים / Деревянный машкоф двери внутр. царапины, удары

ליקוי: במלבני העץ של דלתות הפנים ישנם פגמים.
נדרש: להחליף.

## סיום הריצוף לקוי (אין פנלים) / нет панелей в кв

ליקוי: אין פנלים.
נדרש: יש להדביק פנלים.

## רוחב משיקים  פחות מ3 מ"מ / ширина между плиткой на полу меньше 3 мм

ליקוי: נמצא שהאריחים רוצפו ללא רוחב מינימלי של 3 מ"מ:
הדבר בניגוד לדרישות ת''י 1555 חלק 3 סעיף 4,6,1 ,ציטוט:

כמו כן נדרשת אחידות ברוחב המישקים ע''פ ת''י 1555 חלק 3 סעיף 5.1.4.3 ציטוט:

נדרש: לפרק את האריחים ולהתקין מחדש.

## שיפוע בתוך הדירה מעל (מעל 6 מ"מ אסור , עד 5 מ"מ מותר) / уклон в квартире  больше 5мм ( больше 4 мм на 2 метра)

ליקוי: שיפוע מפלס פני הרצפה המוגמרים לקוי. נדרש כי סטיית פני הריצוף לא יהיו גדולים מ- 4 מ"מ לאורך קו של 2 מ', כלומר בשיפוע מקסימאלי של 0.2% .בפועל בוצע ___
וזאת בניגוד להנחיות תקן 1555 חלק 3 , ציטוט:

נדרש: פירוק הריצוף באזורים המשופעים והתקנה מחודשת מהמין הקיים במפלס אחיד.

## ליקוי: סימני רטיבות בקיר. סיבה: בידוד תרמי לקוי

ליקוי: נראים סימני רטיבות בקיר. הסימנים מלווים בהתקלפות והתנפחות של שכבת הטיח והצבע. לפי התמונות התרמיות ולפי קריאות המד לחות ניתן לראות לחות גבוהה במקום הנבדק.
סיבה: בידוד תרמי לקוי.
בעיות עיבוי ניתנות לפתרון באמצעות מספר אמצעים:
א. הוספת טיח תרמי פנימי בעובי ממוצע של 4-3 סמ\`, בתוספת שכבת גמר "שליכט" וצביעה בסיד סינטטי נגד עובש.
ג. הוספת שכבת בידוד חיצונית, כגון פוליאוריטן מוקצף או "קל קר", בעובי 2-4 סמ\` וציפוי עמיד.
ד. הוספת שכבת בידוד פנימית עשוייה "קל קר" או צמר סלעים בעובי 3-2.5 סמ\`, עם ציפוי לוחות גבס משוריין וגמר בסיד סינטטי נגד עובש.
ה. אוורור החלל הפנימי של המבנה.

## איטום בין שיש מטבח לקיר

ליקוי: חסרה אטימה בין חיפוי הקרמיקה למשטח השיש.במצב הקיים, יחדרו מים לתוך הארונות.
נדרש: לבצע השלמת אטימה בסיליקון דוחה עובש.
הליקוי אסור עפ"י 3.1.3 בהל"ת 2012 , ציטוט:
קבועת שרברבות תותקן בצורה המאפשרת גישה נוחה לניקוייה. במקרים בהם הקבועה נוגעת בקיר או ברצפה, יהיו שטחי המגע אטימי מים.

## תפקוד של לחצן האסלה לקוי

ליקוי: תפקוד של לחצן האסלה לקוי.
נדרש: לבצע תיקון הנדרש על מנת להביא למצב תקין.

## חסר את סגר ביטחון לדלת כניסה / нет сэгэр битахон

ליקוי: חסר סגר ביטחון לדלת כניסה, בניגוד לדרישות ת"י 5044.
נדרש: התקנת סגר ביטחון בהתאם לתקן.

## אריחי קרמיקה אינם במישור אחיד / нет соосности по плиткам (стены)

ליקוי: אריחי קרמיקה אינם במישור אחיד. קיימים אריחים אשר אינם במישור הכללי של הקירות.
ליקוי נוצר עקב עבודות הרכבה לא מקצועיות של החיפוי. במצב הקיים נוצר מפגע אסתטי בולט לעין.
נדרש: פירוק אריחים, התקנה מחדש במישור אחיד.

## מפתן הדלת עקום/  Кривой порог

ליקוי: מפתן הדלת עקום.
סטייה זוויתית מקו ישר בריצוף סף הדלת.
נדרש: לבצע פירוק מלבן הדלת, פילוס הקירות הסמוכים והתקנת מלבן חדש.

## מרווח בין הזכוכיות משתנה / между стеклами разное расстояние

ליקוי: מרווח בין הזכוכיות משתנה
נדרש: יש לפרק את ההלבשה וליישר את הזכוכית (עלות התחלתית).

## רובה לא גמישה בין פנל  למעקה/קופינג / На балконе между панелью и коппингом роба не гмиша

ליקוי: מישקי התפשטות מלאים בחומר קשיח (רובה) במקום חומר גמיש (מסטיק).
מדובר בפרט המועד לפורענות מחמת סדיקה וניתוק מילוי הרובה עקב מאמצים פנימיים הנוצרים בתוך מערכת האריחים.
נדרש: יש לחרוץ את הרובה הקיימת לרוחב ולפתוח מישק ברוחב לפחות 4-6 ס"מ ולבצע מילוי חומר איטום גמיש.



## שריטות בזכוכית חלון ומעקה מרפסת / Царапины на стекле окна и (маакэ) балкона

ליקוי: שריטות על שמשת הזכוכית, זאת בניגוד לת"י 4068 חלק 1 סעיף 4.1 האוסר פגיעות מכניות (קמטים, שריטות, שברים) ופגיעות כימיות (איכול, חספוס שנגרם ע"י מלט או סיד, גימום וכתימה) במוצר.
נדרש: לתקן הפגמים עד למראה אחיד ובמידת הצורך להחליף באלמנט תקין.


## תפקוד הידית החלון לקוי / Рукоядка окна не работает

ליקוי: תפקוד הידית בחלון לקוי – אינה נפתחת/נסגרת בצורה תקינה, דבר הפוגע בשימושיות ובבטיחות.
נדרש: לתקן או להחליף את מנגנון הידית כדי להבטיח פתיחה וסגירה תקינה של החלון.

## שיש מטבח  פגמים /שריטות

ליקוי: בשיש המטבח קיימים פגמים בולטים לעין מסוג מעיכות ושריטות.
נדרש: להחליף/לתקן את החלקים הפגומים.

## שקע חשמל רחוקה ממערכת הסינון / розетка далеко установлена (больше 1 м) от маарэхэт синун мамада

ליקוי: שקע חשמל למערכת סינון הותקן רחוק מדי ממיקום תושבת קיבוע המסנן. במצב חירום בו יהיה צורך לבצע שימוש במסנן לא תהיה אפשרות לבצע חיבור לחשמל.
נדרש: לשנות את מיקום השקע.

## חוסר מוט אופקי במסתור כביסה / Хосер мот битахон в м.квисе

ליקוי:לא הותקן מוט מתכת לבטיחות לאורך המסתור.
נדרש: יש להתקין מוט מחסום אופקי למניעת נפילת אדם לכל אורך המסתור ו/או  להגיש לרוכשי הנכס אישור מהנדס ו/או בדיקת מכון מוסמך כי כל רכיבי המסתור עומדים בעומס של מינימום 500 ניוטון למ"ר.
זאת בניגוד לתקן 5100 סעיף 3.2.2.1 - גובה המסתור מפני משטח הדריכה יהיה 105 ס"מ לפחות. אם המרווח בין קצה משטח הדריכה לבין המסתור אינו גדול מ 10- ס"מ, יכלול המסתור רכיב אופקי בהתאם למתואר בסעיף 3.2.2.2; הרכיב האופקי יימצא לכל אורך המסתור. אם המרווח בין קצה משטח הדריכה ריכה לבין המסתור גדול מ10- ס"מ, יש להציב בקצה משטח הדריכה מעקה המתאים לדרישות התקן הישראלי ת"י .1142.
להלן תמונה שיכולה להוות דוגמה לכוונת כללי המקצוע ו/או התקנים הנותן עדות לדוגמא (יכולות להיות דוגמאות טובות נוספות אחרות מעבר לתמונה זו.
&nbsp;
מצ"ב צילום להמחשת הליקוי (צולם בנכס אחר)



## פעמון אינו פעיל / звонок не работает

ליקוי: פעמון אינו פעיל.
נדרש: יש לבצע בדיקה כוללת לתקינות המערכת, חיבורים, הזנות וחיווטים.

## מנעול דלת לא תקין / Замок двери не работает

ליקוי: מנעול הורכב בצורה לא תקינה ולא מתפקד בצורה חלקה, וזאת בניגוד להוראות תקן 23.6.
נדרש: כיוון ו/או שימון ו/או הרכבת מנעול מחדש.


## שיפוע אדן חלון לקוי מינימום 1-3% / Плохой уклон подоконика мин 1%-30%

ליקוי: שיפוע אדן חלון לקוי.
שיפוע אדן חלון חייב להיות לפחות 1% - 3%.
נדרש: פירוק חלון, התקנת חלון עם שיפוע תקין.

## Пусто



## חסר מתג/ Отсутствует метег

ליקוי: חסר מתג.
נדרש: להתקין .

## ידית דלת הותקנה בגובה לא תקני

ליקוי: ידית דלת הותקנה בגובה לא תקני, גובה הידית הנמדד הינו ____ מ' .
זה נוגד לתקן 23 חלק 3 סעיף 2.2.1 מרכז קידוח עבור התקנת ידית הדלת יהיה בין 101 ס"מ לבין 97 ס"מ.
נדרש: לפרק את הדלת ולהחליפה בדלת בעלת גובה ידית תקנית הנע בין 97 ס"מ ל 101- ס"מ.

## לא הורכבו אביזרים למניעת הרמת כנפיים / В верху витрине не установлен стопер

ליקוי: לא הורכבו אביזרים למניעת הרמת כנפיים .
נדרש: להשלים.


## גמר לקוי בתפר של קירות חיצונים / мирпесет хибур между нар.стенами (мастик)

ליקוי: גמר לקוי בתפר של קירות חיצונים.
נדרש: לבצע תיקוני גמר לפי אופי הליקוי.

## מילוי רובה לקוי / роба  милуй плохое заполнение

ליקוי: מישקי הריצוף בדירה אינם מלאים עד גדותם. וזאת בניגוד להוראות ת"י 1555.3 ו - 314.
הליקוי מתבטא למילוי רובה בצורה שקועה ביחס לרום מישקי הריצוף,
וגורם להצטברות של לכלוך במישקי הריצוף.
מצ"ב ציטוט סעיפים 3.1 ו – 4.6.4 מת"י 1555.3 הדן ב – "ריצוף באריחי קרמיקה"

נדרש:
א. לחרוץ את הרובה המתפוררת לכל עובי האריח.
ב. לנקות היטב את המישקים.
ג. למלא רובה אקרילית לכל עומק המישק ועד לתחתית האריחים בגוון התואם לגוון שהוזמן.

## חסרים שסתומי מים חד כיווניים בפתחי הניקוז בתחתית פרופיל אלומיניום/нет дренажных пкаков в месиле

ליקוי: חסרים שסתומי ניקוז בתחתית פרופיל האלומיניום, בניגוד לת"י 4068 חלק 1 סעיף 7.4. ללא שסתומים אלו, עלול להיווצר כשל בניקוז המים, וכן חדירת מים, רוח וחרקים לחלל המסילה.
נדרש: להשלים את התקנת שסתומי הניקוז בפרופילי האלומיניום כדי להבטיח ניקוז תקין והגנה על המערכת.



## לוח אקוסטית בתקרה פגום/пгима бе луах акустик панель тикры

ליקוי: לוח אקוסטית בתקרה פגום.
נדרש: להחליף.

## תפקוד מתג ויטרינה/Метег витрина плохо работает

ליקוי: תפקוד המתג הויטרינה לקוי.
נדרש: להחליפו.

## נזילה בסיפון

ליקוי: נזילה בסיפון, שעלולה לגרום להצטברות מים ונזקי רטיבות בארון הכיור.
נדרש: לבצע תיקון נדרש ולהחזיר את המצב לתקין, או להחליף לסיפון חדש.

## תריס  לא עובד / трис не работает

ליקוי: תריס אינו מתפקד כראוי.
נדרש: לתקן את התריס ולהביאו למצב שימוש תקין.

## רטיבות (איתור אינסטלציה+בדיקת לחות) / Ративут (сантех пр. и бд. лэхут)

ליקוי:נראים סימני רטיבות מעל הפנלים .הסימנים מלווים בהתקלפות והתנפחות של שכבת הטיח והצבע.
מד הלחות מצביע על לחות גבוהה במקום הנבדק.
רטיבות זו מתאפיינת כתופעה המוכרת בשם "עלייה קפילארית (נימית) אשר פי הממצאים נובעת ממים כלואים במצעי הריצוף.
זה נוגד, לת"י 1555 פרק 3 (2003) סעיף 2.1.4.
נדרש:
1. נדרש לבצע בדיקת אטימות כוללת למערכת אספקת המים וזאת לפי הנחיות תקן 1205 חלק 6 נספח ג 1 , ציטוט:

2. י ש לבצע בדיקת אטימות כוללת למערכת ניקוז המים (דלוחין ושופכין). וזאת לפי הנחיות תקן 1205 חלק 6
נספח ג 2.2- , ציטוט:

3. לקחת דגימות מצע . לפי תוצאות בדיקה מעבדתית יש להחליף או לייבש את המצע בכל חדר שבו התגלה לחות גבוהה ממה שמותר בתקן 1555 פרק 3 (2003) סעיף 2.1.4 (תכולת לחות לא יותר מ – %6 חול, 3% סומסום).
4. לאחר הייבוש המלא והסופי של הקירות יש לבצע תיקוני שפכטל וצבע במקומות שנפגעו מן הרטיבות.
הערה: עלות זאת כוללת איתור מקור הנזילה, עלות לא כוללת תיקון, ייבוש תת רצפתי ותיקוני צבע.

## טרם הסתיימה התקנת הכלים הסניטרים והאביזרים בבית

הערה: טרם הסתיימה התקנת הכלים הסניטרים והאביזרים (ברזים, מכסים וכד') ברחבי הנכס.

## קיים חשד לחדירת רטיבות מכיוון קיר חיצוני / По термо съемке есть подозрение проникновение воды через наружную стену

ליקוי: לפי צילום תרמי קיים חשד לחדירת רטיבות מכיוון קיר חיצוני.
נדרש: לעקוב, במידה ויופיעו סימני רטיבות יש לאתר ולתקן את מקור הבעיה.


## מרווח במשקוף הדלת / Машкоф двери дефект сборки (соосность)

ליקוי: הלבשת דלת (סרגלי הכיסוי) מותקנת בחוסר דיוק כלפי ו/או אינו מודבקים זה לזה, וזאת בניגוד להוראות ת"י 23.2 והן בניגוד לכללי המקצוע הטובים המקובלים בענף.
כלומר קיים מרווח ו/או בליטה חריגה בין הלבשה המהווה הפרעה אסתטית הבולטת לעין.
נדרש: לפרק ולהרכיב מחדש כראוי בצורה מקצועית.


## טרם הושלמה רובה במישק המחבר בין הרצפה לקיר ובין קיר לקיר/нет робы кир-рицпа эластичным хомером

הערה: טרם הושלמה רובה במישק המחבר בין הרצפה לקיר ובין קיר לקיר.
נדרש: להשלים איטום בחומר גמיש. לפי הנחיות תקן 1555 חלק 2 סעיף 4.7 וחלק 3.


## בדיקת לחות+מחיר

רטיבות זו מתאפיינת כתופעה המוכרת בשם "עלייה קפילארית" (נימית) אשר לפי הממצאים נובעת ממים כלואים במצעי הריצוף.

ליקוי זה מנוגד לת"י  1555 פרק 3 (2003) סעיף 2.1.4.
התקן הישראלי – 1555 חלק 3, סעיף 2.1.4  קובע – "תכולת הרטיבות של התשתית אחרי סיום הנחת האריחים לא תהיה גדולה מ – 6% כשהתשתית עשויה חול, ולא תהיה גדולה מ3% כשהתשתית עשויה אגרגאטים המכונים סומסום."
במידה ורמת הלחות הכלואה ברצפה גבוהה מהמותר יהיו לכך השלכות בדמות ספיגה קפילארית בקירות הגורמות לקילופי צבע, שקיעות בריצוף, עיוותים בפרקטים, התנפחויות בסוקלים של ארונות, ריחות עובש בארונות, משקופי דלתות נאכלים, חלודה בצינורות מתכת העוברות ברצפה, והגרוע מכל, נזקים בקונסטרוקציית המבנה. לכן, על פי נתוני הבדיקה ניתן לתכנן את אופן הטיפול ובכך למנוע נזקים עתידיים חמורים יותר.

מסיבה זו, נדרש לבצע בדיקה מיוחדת (נוספת) בה תילקח דגימת לחות מתחת לריצוף.
שאלות נפוצות:
שאלה: מהי בדיקת לחות?

תשובה: מטרת בדיקת הלחות היא לקבל נתונים מדויקים אודות רמות המים הכלואים מתחת לריצוף. כשמבצעים את הבדיקה אפשר לקבוע האם אחוזי הלחות במקומות אלה עומדים בתקן הישראלי, נמוכים מהתקן או גבוהים ממנו.

שאלה: עשיתי בדיקת לחות וקיבלתי את אחוזי הלחות, מה שלב הבא?

תשובה: תלוי איזה רמת לחות קיבלת, במידה ואחוז הלחות יותר גבוה מהמותר בתקן יש צורך לבצע ייבוש תת רצפתי.

הערה: אציין שאחוז הלחות בחול המותר עפ"י התקן   1555 פרק 3  סעיף 2.1.4  הוא 6% חול ו- 3% סומסום.

במידה ואחוז הלחות גבולי מבחינת התקן, אז קיימת אפשרות שהרצפה תתייבש בעצמה בעוד מספר חודשים.

במידה ואחוז הלחות נמוך מ6% חול ו-3% סומסום, זה אומר שהרצפה כבר התייבשה ורק נותרו שאריות רטיבות בקיר. במקרה זה אין צורך לבצע ייבוש, רק צריך לחכות עד שהקיר יתייבש ולבצע תיקוני צבע.

שאלה: איך מבצעים את הבדיקה?

תשובה: בחדר בו מופיעים סימני הרטיבות הבודק מבצע קידוח ברצפה. הקידוחים מבוצעים במקומות נסתרים (במקומות בהם המצע הוא חולי הקידוח יהיה בקוטר של 10-8 מילימטר ואילו במקומות עם מצע "סומסום" –בקוטר של כ-50 מילימטר).

קידוחים אלו כמעט שאינם נראים לעין ולרוב אין צורך בלמעלה מחמישה קידוחים לכל היותר.

הדגימות מגיעות למעבדה המקצועית שלנו, שם מבוצעת בדיקה תוך 12 שעות מיום לקיחת הדגימות.

לאחר קבלת התוצאות ניתן לקבוע את הטיפול המתאים ברטיבות בביתכם.

שאלה: כמה עולה בדיקה?

תשובה: מחיר הבדיקה הינו 1,000 ₪, במידה ואתם לקוחות שלנו המחיר בשבילכם יהיה 500 ₪.

שאלה: האם אתם גם מבצעים ייבוש תת רצפתי?

תשובה: אנחנו לא מבצעים את הייבוש, מהסיבה שאנו רוצים לשמור על ניטרליות ולהימנע מניגוד אינטרסים מול לקוחותינו בהתחשב בכך שאנו אלה שמבצעים את בדיקת הלחות. במידה ותהיו מעוניינים בהמלצה על בעל מקצוע לצורך ייבוש, נשמח לסייע ולקשר אתכם לבעל המקצוע המתאים.

&nbsp;

&nbsp;

&nbsp;

&nbsp;

&nbsp;

## בדיקת לחות

רטיבות זו מתאפיינת כתופעה המוכרת בשם "עלייה קפילארית" (נימית) אשר לפי הממצאים נובעת ממים כלואים במצעי הריצוף.

ליקוי זה מנוגד לת"י  1555 פרק 3 (2003) סעיף 2.1.4.
התקן הישראלי – 1555 חלק 3, סעיף 2.1.4  קובע – "תכולת הרטיבות של התשתית אחרי סיום הנחת האריחים לא תהיה גדולה מ – 6% כשהתשתית עשויה חול, ולא תהיה גדולה מ3% כשהתשתית עשויה אגרגאטים המכונים סומסום."
במידה ורמת הלחות הכלואה ברצפה גבוהה מהמותר יהיו לכך השלכות בדמות ספיגה קפילארית בקירות הגורמות לקילופי צבע, שקיעות בריצוף, עיוותים בפרקטים, התנפחויות בסוקלים של ארונות, ריחות עובש בארונות, משקופי דלתות נאכלים, חלודה בצינורות מתכת העוברות ברצפה, והגרוע מכל, נזקים בקונסטרוקציית המבנה. לכן, על פי נתוני הבדיקה ניתן לתכנן את אופן הטיפול ובכך למנוע נזקים עתידיים חמורים יותר.

מסיבה זו, נדרש לבצע בדיקה מיוחדת (נוספת) בה תילקח דגימת לחות מתחת לריצוף.

## מראה רובה עם גוון שונה/изменение цвета робы в полах

ליקוי: מראה מילוי הרובה במשקי הריצוף בוצע עם הבדלי גוון, וזאת בניגוד להוראות תקן 1555.3.
נדרש : לחרוץ רובה לכל עובי האריח, לנקות את המישקים מלכלוך שיירי בנייה ולבצע מילוי רובה אקרילית לכל עומק המישק הריצוף.

&nbsp;

## ריצוף: לא נמצאו ליקוים מהותיים.

ריצוף: לא נמצאו ליקוים מהותיים.

## סימן רטיבות -   תרמי תקין

בדיקה: ביום הבדיקה לא נמצאו סימני רטיבות באזור הנבדק.
הבדיקה בוצעה באמצעות מצלמה תרמית, והתוצאות אינן מצביעות על הימצאות לחות חריגה.
מומלץ: לעקוב אחרי האזור לאחר איכלוס הבניין. במידה והרטיבות תחזור, יש לאתר את מקור הרטיבות ולבצע תיקון בהתאם.
עלות: ללא עלות כרגע

## נגרות: לא נמצאו ליקוים מהותיים.

נגרות: לא נמצאו ליקוים מהותיים.

## אינסטלציה  - תקין

עבודות אינסטלציה סניטארית: נבדקו עבודות אינסטלציה סניטארית וניקוז ונמצאו במצב - תקין.

## בטיחות: לא נמצאו ליקוים מהותיים.

בטיחות: לא נמצאו ליקוים מהותיים.

## מסגרות: נבדקו עבודות מסגרות ונמצאו במצב - תקין.

מסגרות: נבדקו עבודות מסגרות ונמצאו במצב - תקין.

## סטיות ואי התאמות:  לא נמצאו ליקוים מהותיים.

סטיות ואי התאמות: לא נמצאו ליקוים מהותיים.

## חיפוי קרמי: בחדר רחצה  בחיפוי הקירות אשר נעשה ע"י אריחי קרמיקה לא נמצאו ליקוים מהותיים.

חיפוי קרמי: בחדר רחצה בחיפוי הקירות אשר נעשה ע"י אריחי קרמיקה לא נמצאו ליקוים מהותיים.

## שליכט בכל קיר מחדש/амлацот тикун сдеким бе шлихт

נדרש:
1. יש לבצע עבודות איטום בקיר חיצוני: לגרד שליכט הקיים, לסגור ולאטום את כל החורים והפגיעות שקיימים בקיר.
הערה: סדקים רחבים יש להרחיב ולאטום עם מסטיק פוליאוריטני כגון ה"סיקה פלקס 11FC+". סדקים דקיקים נאטמים על ידי מרק גמיש שמסופק בד"כ כחלק מממערכת הצבע הגמיש של היצרנים.
2. יש ליישם שליכט חדש על הקיר.
2. אחרי התיקון יש לבצע בדיקת המטרה לקיר לפי ת"י 1476 חלק 2 .
במידה ועדיין תהיה חדירת מים יש לבצע איטום מחדש בכל הקיר.

## לא הותקן עינית לדלת כניסה / Не установлен глазок в двери

ליקוי: לא הותקן עינית לדלת כניסה.
נדרש: להתקין עינית לדלת כניסה

## חסרה ידית לסגירת חלון ממ"ד / нет ручки для герметич. закр окна мамада или сломано

ליקוי: מנגנון הנעילה של חלון הממ"ד חסר או שבור, דבר הפוגע בבטיחות ובאטימה של החלון.
נדרש: להחליף או לתקן את מנגנון הנעילה, ולוודא שהחלון נסגר וננעל באופן תקין.

## רובה לקוי חיבור פנל-רצפה בכל הדירה / По всей квартире роба хибур панель рицпа не эласти

ליקוי: לא בוצעו מישקי הפרדה בין השיפולים לריצוף , זאת בהתאם לתקן 1555 חלק 3.
כמו כן המילוי והאטימה בין השיפולים לריצוף נעשו ע”י חומר לא תיקני.
בפועל בוצע מילוי רובה כאשר עפ”י דרישת התקן יש לבצע זאת ע”י חומר גמיש מתאים.
מיקום: ריצוף בדירה , מלבד בחדרי הרחצה
נדרש: יש לפרק את השיפולים באופן מלא. להכין את הקירות להרכבת שיפולים חוזרת, לייצר ולספק שיפולים חדשים, להרכיבם מחדש.
העבודה כוללת תיקוני טיח מעל השיפולים החדשים וצביעת דירות הדירה באופן מלא וזאת על מנת לשמור על אחידות הצביעה בין המקומות המתוקנים ליתר הקירות.
מצ"ב צילום להמחשת הליקוי (צולם בנכס אחר)

ציטוט:זאת בהתאם לתקן 1555 חלק 3


## סף האלומיניום מתחת לחלון הורכב עם שיפוע  הפוך / Саф алуминия окна установлен во внутрь окна

ליקוי: סף האלומיניום מתחת לחלון הורכב עם שיפוע נגדי - כלפי החלון. ליקוי זה יגרום לחדירת מים אל תוך הדירה ולייצור רטיבות מתחת לחלון.
נדרש: לשנות שיפוע של הסף החלון ולאטום מחדש. למיטב הבנתי התיקון הנ"ל דורש פירוק חלון.

## נמצאו שריטות(פגמים) בזכוכית הוויטרינה / Царапины (удары) на стекле витрины

ליקוי: נמצאו שריטות/פגמים בזכוכית הוויטרינה.
זאת בניגוד לת"י 938 חלק 1
נדרש: נדרש לבצע החלפת הזכוכית הפגומה.


## השיש  במטבח רופף (לא נדבק)

ליקוי: השיש של משטח העבודה כלל לא נדבק לראשי הארונות, אינו יציב, מתנדנד, מתרומם ועתידי להישבר.
נדרש: לבצע קיבוע השיש תקין.

## במשקוף הדלת הפתח ללשונית המנעול נפתח בצורה לא תקינה/ликуй отверстия под язычок замка двери

ליקוי: במשקוף הדלת הפתח ללשונית המנעול נפתח בצורה לא תקינה, כלל לא אסתטית ואף מהווה מפגע בטיחותי ע"י שאריות פח חדות.
נדרש: להמציא פתרון לבעיה המתוארת. אחת מהאופציות הינה התקנת שקע פלסטיק או פח.

## חסרים פתחי ניקוז במסילה / Нет никуза в месиле

ליקוי: חסרים פתחי ניקוז במסילה.
נדרש: לבצע פתחי הניקוז או להגביה את המסילה


## מרווח קטן בין דלת למשקוף/кнаф делет не крепится к раме

ליקוי: כנף הדלת לא צמודה למשקוף. כתוצאה מכך הבידוד האקוסטי של הדלת נמוך ולא תקין. כמו כן קיים מפגע אסתטי.
נדרש: לבצע תיקון הנדרש על מנת להביא למצב תקין.

## צינור ניקוז של הדוד לא מחובר לנקודת הניקוז ברצפת המסתור / Никуз дуда не подкл. к никузу пола м.квисы

ליקוי: צינור ניקוז של הדוד לא מחובר לנקודת הניקוז ברצפת המסתור.
נדרש: להאריך את צינור הניקוז ולחברו לנקודת הניקוז ברצפה.

## חסר חור למייבש כביסה / Сушилка: нет отверстия

ליקוי: לא נמצא פתח למייבש הכביסה. כמו כן לא הותקנו תריס מתאים בצדו של הפתח החיצוני וטבעת פלסטיק ופקק בצדו הפנימי של הפתח.
נדרש:
1. יש לבצע עיון במפרט הטכני.
2. במידה והדבר אכן מופיע במפרט, אז יש לבצע קידוח בקיר שבין מרפסת השירות לבין מסתור הכביסה, להרכיב תריס על הפתח בתחום של מסתור הכביסה ולהרכיב תבעת פלסטיק כולל מכסה על הפתח בתחום של מרפסת שירות.
&nbsp;

## לשון ידית דלת לא נסגרת/נכנסת טוב / Верхний язычок замка не входит в паз

ליקוי: נוצר מרווח גדול ולא תקין בין כנף הדלת למשקוף.
עקב כך לשונית המנעול הורחקה מהמשקוף והדלת לא הייתה ננעלת בכלל.
נדרש: למרכז כנף הדלת ביחס למשקוף. לאחר התיקון חובה לבצע בדיקות אטימות הממ"ד חוזרת ע"י מעבדה מוסמכת.

## שיש לא מחובר לארון/шаиш плохо приклеен к арону

ליקוי: השיש של משטח העבודה כלל לא נדבק לראשי הארונות, אינו יציב, מתנדנד, מתרומם ועתידי להישבר.
נדרש: לבצע קיבוע השיש תקין.


## פס הפרדה  במקלחת בולט מפני הרצפה/металлический паз в рицпе миклахата  выше уровня пола

ליקוי: בשולי תא המקלחת התגלה כי פס הפרדה ממתכת בולט מפני מפלס הריצוף, וזאת בניגוד המקצוע הטובים המקובלים בענף. הליקוי מתבטא במכשול בטיחותי העלול לגרום למעידה ופציעה בעת השימוש במקלחת.
נדרש: חיתוך ו/או שיוף בצורה אסתטית.

## חוסר גמר  קרמיקה מעל  הדלת (אזור משקוף)/ Нет карамики  над машкофом двери х.рахаца

ליקוי: חוסר גמר חיפוי קרמיקה מעל פתח הדלת. הדבר מתבטא באי אחידות בין קו חיפוי הקרמיקה לקו גובה פתח הדלת המהווה הפרעה אסתטית הבולטת לעין, וזאת בניגוד לכללי המקצוע הטובים המקובלים בענף.
נדרש: השלמת חתיכת קרמיקה מעל פתח הדלת.

## אותרו שריטות (נזקים) במעקה במרפסת/  царапины на маакэ мирпесета

ליקוי: פרופיל אחיזת המעקה התגלו סימני נזק (שריטות ו/או קילופי צבע), וזאת בניגוד להוראות תקן 4402.2, 1142.
נדרש: תיקון פחחות או צביעה אסתטית בשיטת התזה באמצעות ספריי אירוסול בגוון תואם מניפת הצבע של היצרן.


## תנועה לא תקינה וקשה של הכנף ויטרינה / Тяжелое закрытие/движение витрины

ליקוי: בבדיקת הזזה ידנית אינטואיטיבית של אגפי הוויטרינה אובחנה כי נדרשת הפעלת כוח בלתי סביר, וזאת בניגוד להוראות תקן 4001.1.
נדרש: כיוון ו/או שחרור ו/או ניקיון ו/או החלפת גלגלים.


## מרווח פנימי של ארגז תריס מעל 10 ס"מ, חוסר סרגל זוויתן / Расстояние в верху трисов больше 10 см

ליקוי: בין מסילת תריס הגלילה לארגז התריס נמדד מרווח פנימי העולה 10 מ"מ, וזאת בניגוד לראות תקן 1509.2. הליקוי בין היתר מתבטא בחוסר סרגל זוויתן פנימי המשולב במברשת.
נדרש: השלמת סרגל זוויתן כאמור להתקטנת המרווח ל-10 מ"מ לכל היותר.

&nbsp;

## מדרגה יציאה מהבית לחצר מעל 20 ס"מ/мадрега в хацер англит больше 20см

ליקוי: המעבר לחצר אנגלית נעשה באמצעות מדרגות בגובה כ  ____ ס"מ. לפי סעיף 3.8.4.5 לתכנית התכנון והבניה, מותרת מדרגה בגובה עד 20 ס"מ ביציאה לחצר.
נדרש:
- הנמכת המדרגה לגובה תקני כולל עבודות הכרוכות בכך.
- במידה ויוחלט בהסכמה בין הצדדים כי תיקון הליקוי בלתי מעשי/ כדאי אז יש לפצות את המזמין בגובה עלות התיקון.

## מרחלק יותר מ 40 ס"מ מאסלה לקיר/нет 40см от ацлы до кира

ליקוי: נמדד מרחק של _____ ס"מ בין האסלה לקיר, בניגוד לדרישות ההל"ת המחייבות לפחות 40 ס"מ.
נדרש : להזיז את האסלה כך שהמרחק בינה לבין הקיר יהיה 40 ס"מ, בהתאם להל"ת.


## מים עולים מקופסת ביקורת בזמן שימוש באמבטיה/поднятие уровня воды в куфсат бикоретах

ליקוי: בבדיקת ניקוז האמבטיה לאחר מילויה נמצא כי המים עולים על גדותיהם בתוך קופסת ביקורת. קיימות סיבות שונות לגלישת מים מחוץ לקופסה ביקורת ,לדוגמא: סתימה בצינור הניקוז או שפוע בלתי תקני.
נדרש:
- שטיפה וניקוי צנרת ניקוז של האמבטיה.
- במידה והליקוי חוזר על עצמו לאחר שטיפת הצנרת יש לבצע צילום פנים צנרת באמצעות סיב אופטי (מצלמת ביוב) המאפשר לאבחן את הצינור מבפנים ולזהות את הכשל.

## אינסרט: אזור התחתון של הדלת מרווח יותר מ 5 ס"מ/нет нижней вставки вх.дверь

ליקוי: בתחתית דלת הכניסה לנכס נמדד מרווח העולה על 3-5 מ"מ, וזאת בניגוד להוראות ת"' 5044.2.
נדרש: כיוון אינסרט לקבלת מרווח תקני.


## סימני מליחות ברובה באזור נקז כפול במרפסת / Кристаллы соли вокруг никуза мирпесета

ליקוי: אותרו סימני מליחות ברובה, סימנים אלו מעידים על מים כלואים במצעי הריצוף. הדבר מעיד על חשד לסתימה ו/או אי תפקוד בנקז הכפול ו/או שיפוע תת רצפתי בלתי תקני לתשתית שכבת איטום המרפסת. ‏יובהר כי הנקז הכפול מיועד לניקוז מים הנספגים אל מתחת לשכבת הריצוף ומכונה גם "ניקוז דו מפלסי" מכיוון שהוא מנקז את המים הניגרים במפלס הריצוף והן את המים הכלואים מתחתיו.
נדרש:
-פירוק ריצוף באזור הנקז הכפול .
- חשיפת ופתיחת נתיב ניקוז המים אל הנקז הכפול ולוודא תפקוד תקין של הנקז.
- שחזור הריצוף באזור שפורק
- חידוש כללי של רובה הקיימת לקבלת גוון אחיד.
- מעקב אחר הופעות סמני מליחות הריצוף חוזרת.
- במידה והתופעה תחזור אז יהיה צורך בחידוש כלל מערכת הריצוף ת"כ הקפדה על ישום שיפוע תשתית תת רצפתי של 1% עד 1.5% לכיוון הנקז.


## מרווחים פתוחים ללא איטום/רובה במקומות רבים/ зазоры-нет эластичного хомера

ליקוי: מרווחים פתוחים ללא איטום במרק אלסטי ו/או בחומר אחר, וזאת בניגוד לכללי המקצוע הטובים המקובלים בענף.
נדרש: אטימת המרווחים בחומר אלסטומרי ו/או בחומר אחר בהתאמה.

## חסר פס הפרדה בדלת ( כניסה לדלת)/нет саф маим

ליקוי: במפתן הדלת חסר פרופיל סף הפרדה ממתכת, וזאת בניגוד להוראות תקן 1553.3.
נדרש:
- פירוק אריחים באזור סף הדלת.
- להתקין פרופיל סף הפרדה
- להחזיר ריצוף.

## התקנת קופינג ללא קיבוע מכני (ברגים) / Копинг установлен без мех. крепления

ליקוי: אבני קופינג (נדבך ראש) בוצעו ללא קיבוע בברגים, וזאת בניגוד להוראות תקן 2378.4.
נדרש: עיגון אבני קופינג בברגים על פי הוראות תקן 2378.4


## דלת נתקעת ברצפה  (מתחכך) / Затирание (царапание) двери при откр. об пол

ליקוי: אגף הדלת מתחכך/ משתפשף / נתקע הרצפה , וזאת בניגוד להוראות ת" 5044.2.
נדרש: כיוון/ איזון צירי דלת ו/או אינסרט בתחתית הדלת.

## חסרה שקע לתנור חימום / Нет розетки для танура (обогревателя)

ליקוי: חסרה נקודת בית תקע לתנור חימום, וזאת בניגוד למצוין בתכנית מכר.
נדרש: התאמת המצב לתכנית מכר.

## חסר חוט חשמל (חיווט) לשקע תנור בחדר רחצה / Отсутствует проводка для танура (обогревателя) в ванной комнате

ליקוי: חסר חיווט הכולל אביזר קצה עבור תנורי חימום, וזאת בניגוד למתואר במפרט המכר.
נדרש: השלמת נקודת חשמל בהתאם למפרט מכר.

## קופינג פגום, תיקון נקודתי בלי החלפה / Копинг битый - точечный ремонт

ליקוי: חיפוי אבן שבור, בניגוד לת"י 2378.1 סעיף 3.2.1 הקובע כי האבן צריכה להיות שלמה, ללא סדקים או פגמים העלולים לפגוע בחוזקה או במראה שלה.
נדרש: תיקון באמצעות חומר אפוקסי משולב עם פיגמנטים תואמי גוון האבן. במידה והתיקון לא יהיה אסתטי, יש לשקול החלפת האבן.


## מנעול/לשון דלת סגירה לא תקינה/нет регулировки фурнитуры дверногно замка

ליקוי: פרזול נעילת הדלת לא מתפקד בצורה חלקה, וזאת בניגוד להוראות ת" 23.6.
נדרש: כיוון/שחרור/שימון/ התאמת פרזול נעילה.


## חלון "דריי קיפ" סגירה לקויה / Окно драй кип плохое закрытие

ליקוי: אגף חלון "דריי קיפ" מתנגח במסגרת, וזאת בניגוד להוראות ת" 4068.1.

נדרש: שחרור/ כיוון צירים.

## פגם מכאני בפרופיל מסגרת וויטרינה / царапина на мисгерете витрины

ליקוי: פגם מכאני בפרופיל מסגרת, וזאת בניגוד להוראות ת"'4068.1.
נדרש: החלפת פרופיל.


## מערכת סינון בממ“ד מחוברת לא טוב לקיר / Система фильтрации (маарэхэт синун) плохо прикреплена к стене

ליקוי: מערכת סינון בממ“ד מחוברת לא טוב לקיר.
נדרש: לחבר/להצמיד לקיר.

## שריטות בזכוכית חלון / Царапина на окне

ליקוי: שריטות בלוח זכוכית חלון.
נדרש: החלפת זכוכית.

## חסר מחסה לחור מזגן בממ"ד/  Нет михсэ пластик для  мазгана мамад

ליקוי: חסר כיסוי דקורטיבי להסתרת "התקן עומר"
נדרש: להשלים כיסוי דקורטיבי להסתרת "התקן עומר"

## אבן בקיר חיצוני פגום / битый камень на кир хицони-тикун или замена

ליקוי: לוחות אבן פגומים. אותרו פגמים בלוחות אבן החיפוי, וזאת בניגוד להוראות ת"י 2378.1.
מצ"ב ציטוט סעיף 3.2.1 מת"י 2378.1 הדן ב – "קירות המחופים באבן טבעית"

נדרש:
א. להחליף לוח/ות אבן.
ב. לתקן את לוחות האבן באמצעות חומר עמיד בתנאי חוץ .

## חסר סטופר לתריס חשמלי / Стопер для низа трис хашмали

ליקוי: בוויטרינה בה הורכב מנגנון ידני להרמת התריס לא הורכבו  מעצור לתריס גלילה.
חובה להתקין את המעצר על מנת למנוע בליעת התריס אל תוך הארגז.
נדרש:  להתקין מעצור לתריס גלילה.
מצ"ב דוגמא חיובית (צולם בפרויקט אחר)



## איטום בין כיור לקיר / итум киёр-кир

ליקוי: אותרו ליקויי איטום בין כיור לקיר.
נדרש: לבצע איטום בסיליקון דוחה עובש בקו החיבור בין כיור לקיר.
הליקוי הנ"ל בניגוד ל:
1.תקן 1205, חלק 3 – סעיף 2.1 לפיו: "מקום המגע בין קביעת שרברבות לבין סביבתה (קיר,רצפה, משטח עבודה, ריהוט) יהיה אטום מים.
2 .מפרט הכללי לעבודות בניה – סעיף 07042 - לפיו "חיבורי הקבועות לקירות ולרצפות יהיו אטימים,חזקים ויציבים. עם זאת יהיה החיבור גמיש כדי למנוע העברת מאמצים העלולים לפגוע בשלמות הקבועה".

## מתג חשמל הפוך / выключатель установлен наоборот

ליקוי: חיבורי חיווט החשמל הפוכים וכתוצאה גורם להדלקה הפוכה.
הסבר: מפסק התאורה פועל הפוך, כלומר, לחיצה על מפסק מנות האור בחלקו העליון גורם לכיבוי גוף התאורה ולהפך בחלקו התחתון גורם להדלקה.
נדרש: יש לבצע החלפה לחיווט החשמל או להפוך מפסקים.

## מרווח בין חלון לקיר גדול (לא ישר)/мисгерет холон утоплен к керамику

ליקוי: מסגרת חלון מטבח שקועה בחיפוי הקרמיקה של הקיר.
נדרש: יש לבצע את הקרמיקה כך שההלבשה של החלון מתלבשת על חיפוי ולא הפוך. כפשרה, ניתן להציע מסגרת הלבשה נוספת, בכפוף לאישור המזמין.

## ציר שבור בדלת / Дверная петля сломанная

ליקוי: ציר שבור בדלת .
נדרש:  להחליף/ לתקן ציר.


## פינה חדה מעקה מרפסת /  Угол маакэ мирпесета ревах (пина хэда мирпесет)

ליקוי: חיבור בלתי מדויק המתבטא בבליטה ו/או מרווח חריג בין רכיבי בית אחיזת המעקה, וזאת בניגוד להוראות תקן 1142.
נדרש: יש לפרק פרופילים ולבצע הרכבה מחדש בצורה תקינה כלפי החיבור.



## קרמיקה בקיר בולטת מעל חלון / Керамика на стене не на одной линии с окном (выпирает)

ליקוי:  חוסר דיוק בהתקנת ההלבשה כלפי הקיר/קרמיקה.
נדרש: יש לפרק חלקי ההלבשה ולהרכיב מחדש בצורה תקינה, ניתן להציע מסגרת הלבשה נוספת או הוספת מילוי, בכפוף לאישור המזמין.

## שריטה במיכל מים  של דוד \ царапины (удары) на бочке дуда

ליקוי: אותרה שריטה במיכל מים דוד.
נדרש: תיקון שריטה/ לחלופין החלפת דוד (עלות החלפת דוד 3500 שח)

## ריצוף רצפה גוון שונה / Плитка на полу разного цвета

ליקוי: חלק מהריצוף בדירה הותקן בגוון שונה מהשאר, מה שפוגע באחידות המראה הכללי. קיים חשד שברצפה הותקנו אריחים מסדרות ייצור שונות. יוזכר ויודגש כי בשלב זה מדובר בחשד בלבד ולא בקביעה סופית, שכן תנאי התאורה שהיו קיימים בדירה בעת הבדיקה לא אפשרו להגיע למסקנה סופית.
מומלץ לבצע בדיקת ריצוף בשלבים הבאים:
א. להדליק את התאורה בכל חדרי הדירה ולבדוק את הריצוף בתנאי תאורה קבועים ובעוצמה שווה בכל החדרים.
ב. אם הבדיקה הראשונית לא תספק מסקנה ברורה (לאשר או לשלול את הליקוי), יש להזמין לדירה מעבדה מוסמכת לבדיקות מסוג זה לבחינת הריצוף באופן רשמי.
עלות: ללא עלות כרגע, עד לביצוע בדיקות נוספות ואישור הליקוי במידת הצורך.

## חסרים פקקים באביזרי חשמל

ליקוי: חסרים פקקים באביזרי חשמל.
נדרש: להשלים.

## חלודה בברגים במסתור כביסה / халюда (ржавчина) брагим в мистор квисе

ליקוי: ברגים בחיבור בין הרפפות למסגרת ההיקפית הינם מחלידים. הליקוי הזה יכול לגרום להתפרקות ונפילת רפפות. בין יתר הדברים הליקוי הנ''ל מהווה מפגע בטיחותי.
נדרש: להחליפם.

## אין גישה לצינור ניקוז מי גשם (מרזב/נשם) עקב חסימה על ידי מעקה / никуз мааке закрыт перилами

ליקוי: אין גישה לצינור ניקוז מי גשם עקב חסימה על ידי מעקה.
נדרש: לחתוך מכסה לשני חלקים על מנת לאפשר גישה לצינור במידת הצורך.

## סימני מליחות ברובה רצפה מרפסת / соль на робе мирпесета

ליקוי: על פני הרובה בקטעי הריצוף נמצא חומר לבן אשר לא ניתן לזיהוי מדויק. יתכן שהחומר זה הינו שאריות צבע או לכלוך. אך יחד עם זאת יתכן שחומר זה הינו סידן
אשר מעיד על הצטברות מים בתשתית הריצוף ועליית רטיבות קפילארית התשתית על פני הרובה. ואם הליקוי קיים הוא נגרם ע"י אי תקינות של קולט המים או/ו
יפועים לא תקינים ברצפת הבטון שמתחת לריצוף.
נדרש:
1. לנקות היטב את הרובה, כול להחלפת רובה פגומה.
2. לבצע בדיקה חוזרת בסוף החורף הבא / תחילת אביב הבא. במידה ויוכח קיום הרטיבות בתשתית לריצוף, אז יש לבצע 2תיקונים בקולט המים או/ו רצפת הבטון.
הערות: בשלב זה ללא עלות

## חסרה  נקודת עיגון למפוח ידני  של מערכת סינון / Отсутствует кронштейн для ручного управления маарэхэт синун

ליקוי: חסרה נקודת עיגון למפוח ידני .
נדרש: להתקין.
להלן תמונה של נקודת עיגון:


## חסר טיימר לדוד /  не установлен таймер для дуда

ליקוי: חסר קוצב זמן ללוח לחימום מים (טיימר).
נדרש: להשלים לפי המפרט.

## אין שקע לונטה / нет розетки для венты

ליקוי: לא נמצאה נקודת החשמל לונטה
נדרש: לבצע קו חשמל לונטה.

## מתג חשמלי של תריס לא מתאים / выкл. трис хашмали требуется пост.нажатие

ליקוי: סוג של מפסק התריס אינו מתאים למקום ומהווה מפגע בטיחותי.
המפסק הקיים מאפשר ירידת התריס מלאה לאחר לחיצה חד פעמית על לחצן המפסק.
נדרש: להרכיב מפסק אשר דורש לחיצה קבועה על הלחצן בעת ירידת התריס.

## רוחב ויטרינה פחות מ 3 מטר / ширина витрины меньше 3м

ליקוי: אי התאמה בוויטרינה
1. עפ"י מפרט הטכני המצורף לחוזה המכר היה צריך להרכיב את הוויטרינה בסלון כאשר רוחבה המתוכנן 300 ס"מ.
2. בפועל הורכבה וויטרינה בעלת רוחב של 263 ס"מ.
3. ניכרים אי התאמה, הפרת חוזה וירידת ערך הנכס.
נדרש : להזמין שמאי מקרקעין מוסמך לצורך חישוב פיצוי כספי בגין ירידת ערך הנכס / הפרת חוזה.
הערות: בשלב זה ללא עלות


## להסיר ניילון ממעקה ולבדוק תקינות / убрать найлон с маакэ и проверить на царапины

הערה: לפני מסירת הדירה יש להסיר את עטיפת הניילון במעקה ולבדוק תקינות ושלמות של המעקה.

## חיתוך אריח לא מדויק-לקוי/ плохая подрезка вокруг плитки

ליקוי: אותר חיתוך אריח לא מדויק .
נדרש:  לחתוך את האריחים מסביב לאביזר בצורת מעגל או ריבוע, תוך שמירה על דיוק מרבי והתאמה מירבית, על מנת לשפר את האסתטיקה והגימור.

## חוסר דיוק בהתקנת ההלבשה - פינה חדה (פתוחה)  של מסגרת / Плохая стыковка мисгерет (угла) окна/витрины

ליקוי: בפרופילי/הלבשות אלומיניום נמצאו בליטות/פינות חדות בחיבורים, דבר שמהווה סכנה בעת שימוש, וזאת בניגוד להוראות תקן  1068 חלק 2 ותקן 1509 חלק 2 סעיף 3.6.2.1
נדרש: יש לבצע התקנה מחודשת של פרופילי/הלבשות האלומיניום כך שלא יבלטו ממישור הקיר, ולוודא שכל הפינות מעוגלות או מוגנות בהתאם לתקן.


## טרם הותקנה שקע / Не установлена розетка (но есть кабель)


ליקוי: טרם הותקנה שקע (בית תקע) חשמלי.

נדרש: להתקין שקע חשמלי כנ"ל.


## לא נמצא כיסוי/תריס לפתח צינור מייבש 4" / Сушилка: нет пкака для отверстия

ליקוי: לא נמצא מכסה לפתח יציאת אוויר מייבש, וזאת בניגוד למפרט מכר סעיף 3.6 טבלה מס' 4.
נדרש: להשלים התקנת מכסה פלסטיק פנימי וחיצוני לפתח אוויר חם מייבש למניעת חדירת מים ומזיקים
המלצה ע"פ המצויין במפרט המכר.


## איטום קיר/קיר מרפסת / Итум кир/кир мастик на мирпесете

ליקוי: בחיבור בין קיר לקיר במרפסת לא בוצע איטום בחומר אלסטומרי, כנדרש למניעת סדקים וחדירת מים.
נדרש: להסיר את החומר הקיים (במידה ויש) ולבצע איטום בחומר אלסטומרי גמיש בהתאם להנחיות תקן ישראלי ת"י 1555 חלק 3, סעיף 4.7 , ציטוט:


## חסר ארון כיור

ליקוי: חסר ארון כיור.
נדרש: להשלים לפי מפרט.
עלות: ללא עלות כרגע.


## וויטרינה לא יציבה במסילה עליונה / Витрина малый заход в верхнюю месилу

ליקוי: גובה של כנפיים ווירטינה לא תואמת לגובה המסגרת.
נדרש: החלפת כנפיים בגודל תואם.

## חלון קיפ פוגעה בדלת חדר רחצה הורים / Окно "кип" в х.р.горим бьется о дверь

ליקוי: אגף החלון מונח על הדלת כאשר הוא נפתח.
נדרש: לשנות מיקום של פתח החלון ,להרכיב החלון מחדש, כולל כל העבודות נלוות/להגבלת פתיחה 60 מעלות או להתקין מעצר פתיחה.

## חוסר איטום בין מסילות הוויטרינה לרצפה / Нет итума между месилой витрины и полом

ליקוי: חוסר איטום בין מסילות הוויטרינה לרצפה.
נדרש:
- לנקות את האזור מתחת למסילות.
- ליישם חומר איטום איכותי (כגון סיליקון או חומר מתאים אחר) בין המסילות לרצפה.
- לוודא אטימה מלאה כדי למנוע חדירת מים או לכלוך.

## דוד הותקן לא לפי התוכנית/  Дуд установлен не по плану

ליקוי: דוד הותקן לא לפי התוכנית.
נדרש: להתקין דוד לפי תוכנית.

## חלון קיפ  נתקע/ Окно (халон) кип застряло

ליקוי: חלון קיפ  נתקע.
נדרש: תיקון/ כיוון חלון .


## ארון הותקן בצורה עקומה/Монтаж арона кривой

ליקוי: ארון הותקן בצורה עקומה.
נדרש: פירוק והתקנה מחדש.


## תפקוד מתג לקוי/Выключатель нарушена работа

ליקוי: תפקוד מתג לקוי.
נדרש: תיקון ו/או החלפת מתג.

## חסרה פינה בצוקל מטבח/ нет пины цоколь митбаха

ליקוי: חסרה פינה בצוקל מטבח.
נדרש: להשלים.

## לא אותר מחסום ריח/ Отсутствует махсом реах

ליקוי: לא אותר מחסום ריח.
נדרש: להתקין מחסום ריח.

## שיפוע לקויי סביב ניקוז ברצפת מסתור כביסה/Плохой уклон вокруг никуза мистор квисы

ליקוי: שיפוע לקויי סביב לנק' הניקוז ברצפת מסתור כביסה.
נדרש: תיקון שיפוע סביב נק' הניקוז.

## חלון קשה להזזה/Тяжелое открытие окна

ליקוי: תפקוד חלון לקוי (חלון קשה להזזה),וזאת בניגוד להוראות תקן 4068.1.
נדרש: כיוון/ תיקון חלון בהתאם להוראות המפורטות בתקן 4068.1.



## חסרה הלבשה לצוהר אור/нет световой вставки на двери

ליקוי: חסרה הלבשה לצוהר אור.
נדרש: להשלים.

## חלון ממ"ד חלול ללא בטון / пустота в окне мамада (халуль)

ליקוי: בעת הקשה על מלבן חלון הממ"ד נשמע צליל חלול, קיים חשד לחוסר מילוי בטון במלבן חלון הממ"ד, וזאת בניגוד לת"י 4422 חלק 3 סעיף 4.1.3 - רציפות ושלמות היציקה בהיקף הפריט המבוטן.
נדרש: לבדוק את מילוי הבטון, ובמידה וחסר - להשלים את המילוי ולחדש את הצביעה.

## כתמים ושאריות לכלוך/צבע  / пятна и остатки грязи/краски

ליקוי כללי: קיימים כתמים, שאריות צבע ולכלוכים אשר מקורם בעבודות הבנייה שהתבצעו בשטח.
מיקום: במקומות פזורים בנכס, לדוגמא: חלונות, דלתות, שקעים ומפסקים, תריסים, קירות, רצפה, מעקה מרפסת.
נדרש:
1. לבצע עבודות ניקוי יסודי בכל האזורים המוכתמים.
2. לאחר הניקוי, לבדוק אם קיימים ליקויים נוספים כמו שריטות או פגמים, ולתקנם בהתאם.

## מעקה מרפסת עקום / Мааке на балконе установлено криво

ליקוי: מעקה האלומיניום הורכב לא לפי קווי הקופינג ועם סטייה זוויתית.
נדרש : לפרק את המעקה (כולו או צד אחד תלוי במצב) ולהרכיב את המעקה מחדש במקביל לקצוות הקופינג. במידה ויש אריחים עם קידוחים אחרי פירוק/ הזזת מעקה, יש להחליף האריחים עם חורים .

## מלבן (מסגרת) הוויטרינה עקום /  Рама мисгерет витрины перекошена

ליקוי: מלבן הוויטרינה עקום, כנפי הוויטרינה לא מקבלות למלבן. תפקוד ובעיקר אטימות הוויטרינה לקויים.
נדרש:
1. להרכיב את המלבן המתוקן או להתקין מלבן החדש.
2. להרכיב כנפיים.
3. להרכיב את כל האביזרים הנלווים בוויטרינה.
4. לבצע תיקוני גמר משני צדי הוויטרינה - פנים - חוץ.
5. לבצע אטימה בין הוויטרינה לגליפים ולרצפת המרפסת.

## פתיחת חלון קיפ לא תקינה (זווית לא תקין)/Халон кип зазор открытия минимальный

ליקוי: פתיחת חלון קיפ לא תקינה (זווית לא תקין).
נדרש: כיוון חלון.

## חדירת אור במצב סגור של חלון ממ"ד / Хадира света через халон мамад в закр.состоянии

ליקוי: חדירת אור במצב של חלון ממ"ד נעול.
נדרש: כיוון והתאמה של רכיבי הנעילה בחלון למניעת חדירת אור.

## לא הותקן סף  הפרדה/Нет саф афрада

ליקוי: לא הותקן סף מתכת (פס הפרדה) עשוי פליז או אלומיניום כמקובל במשק הפרדה שבין אריחי קרמיקה ברצפת חדר רחצה .
נדרש: להתקין סף אלומיניום או פליז במפתן הדלת בתפר בין הריצופים, להבטחת הפרדה תקינה ואסתטית.


## חוסר איטום סביב  לאינטרפוץ/ хосер итум свив интерпуц

ליקוי: חוסר איטום סביב האינטרפוץ במקלחת – ניתן לראות פתחים גלויים בין גוף הברז לקרמיקה, דבר העלול לאפשר חדירת מים אל תוך הקיר ולגרום לנזק עתידי.
נדרש: לאטום את ההיקף סביב האינטרפוץ באמצעות סיליקון או חומר איטום מתאים לשימוש רטוב.

## חסר בידוד בצנרת סולארית/ Нет бидуда на трубах маарехет солярит

ליקוי: חסר בידוד בצנרת סולארית.
נדרש:  להשלים.

## מכסה קופסת ביקורת זמני/ михсе куфсат бикорета змани, заменить

ליקוי: מכסה קופסת הביקורת הוא זמני ואינו עומד בדרישות התקן, דבר העלול לגרום לריחות ביוב בדירה.
נדרש: החלפת המכסה למכסה תקני ואטום, התואם את קופסת הביקורת, למניעת דליפת ריחות לא נעימים

## חסר מכסה באזור צנרת ביוב /   Отсутствует декор.крышка на 4 цоль биюва

ליקוי: חסר מכסה באזור צנרת ביוב.
נדרש: להשלים.

## קופסת ביקורת לא תקינה (הגבהה/איטום) - куфсат бикорет занижен/итум

ליקוי: גימור ואיטום סביב קופסאות הניקוז לא תקין
נדרש: להתקין הגבהה ו/או לאטום מרווח בין קופסת ביוקרת לרצפה.

## רעש בזמן סגירת הדלת/ скрип во время  закрытия двери

ליקוי: קיים רעש בזמן סגירת הדלת, דבר המעיד על ייתכן חיכוך או כיוון לקוי של הצירים או המנעול.
נדרש:
1. בדיקת הצירים והידוקם או כיוונם מחדש.
2. בדיקת מנגנון המנעול וחיבורי הדלת למשקוף.
3. תיקון החיכוך או החלפת חלקים במידת הצורך.

## חלון ממ"ד מנועל תקוע/ замок халон битахона мамада не работает

ליקוי: בחלון הממ"ד הנועל תקוע.
נדרש: לשחררו.

## וונטה לא עובדת / Вента не работает

ליקוי: וונטה חשמלית לא עובדת .
נדרש: לפנות לחשמלאי לבדיקה ו/או תיקון שלה וונטה.

## פינה חדה אמבטיה / пина хэда амбатия

ליקוי: פינה חדה בחיפוי האמבטיה, העלולה לגרום לפציעות בשימוש יומיומי.
נדרש: יש לתקן פינה חדה בחיפוי האמבטיה אשר עלולה לגרום לפציעות.

## נזילה באסלה / незила в асле

ליקוי: אותרה נזילה באסלה .
נדרש: תיקון על ידי אינסטלטור.

## לא הותקן ברז במרפסת/ Не установлен берез на мирпесете

ליקוי: לא הותקן ברז במרפסת.
נדרש: להתקין ברז במרפסת, כולל חיבור למערכת המים.

## לוח חשמל/תקשורת עקום/ лух хашмаль-тикшорет кривой

ליקוי: לוח חשמל ו/או ארון תקשורת הותקן בצורה עקומה, מה שפוגע באסתטיקה ועלול להעיד על התקנה לא תקנית.
נדרש: ליישר ולכוון את הלוח/הארון כך שיהיה מפולס ומותקן כראוי.

## סימני מליחות ברובה בחדר רחצה/ Мелах бе роба хадарим ратувим

ליקוי:  על פני הרובה בקטעי הריצוף נמצא חומר לבן אשר מעיד על הצטברות מים בתשתית הריצוף ועליית רטיבות קפילארית התשתית על פני הרובה.
נדרש:
1. לבצע בדיקה מקיפה של מערכת אינסטלציה.
2. לאחר איתור ותיקון הבעיה יש לנקות היטב את הרובה, כולל החלפת רובה פגומה.
הערות: בשלב זה ללא עלות

## טרם הותקן מכשיר של מערכת ניטור ובקרת צריכת חשמל/  Не установлен внутренний. эл. учёт хашмаль

ליקוי: טרם הותקן מכשיר של מערכת ניטור ובקרת צריכת חשמל בארון חשמל דירתי.
נדרש: להתקין את הנקודה החסרה, כולל תיקוני טיח וצבע.

## מיכל  אסלה לא צמוד לקיר / Бачок аслы не касается стены

ליקוי: מיכל של האסלה לא הוצמד לקיר.
נדרש: לפרק ולהתקין מחדש בצורה מקצועית.

## צנרת ביוב מאחורי האסלה גלויה בלי קרמיקה/(Канализационная труба за унитазом видна(без керамики

ליקוי: צנרת ביוב מאחורי האסלה חשופה.
נדרש: יש לחפות בקרמיקה צנרת הניקוז האופקית "4 . (הצנרת הקיימת עוברת חשופה בצמוד לרצפה, ומהווה מפגע אסתטי ניכר.

## חיבור בין מעקה לקיר בוצע ללא גמר / Хибур между перилами и стеной мирпесета

ליקוי: חיבור בין המעקה לקיר בוצע ללא גמר וללא סיליקון, מה שעלול לגרום לחדירת מים ולפגיעה באסתטיקה.
נדרש: לבצע אטימה באמצעות סיליקון מתאים לשימוש חיצוני, להבטחת עמידות בפני מים ושיפור המראה.
תקן: המפרט הכללי, סעיפים 12035 ,12034 ,12031 ,12043 ת"י 1068.2, ת"י 1099

## חוסר איטום בין משקוף דלת לרצפה / Хосер итум между машкофом двери и полом

ליקוי: מלבני דלתות הפנים אינם אטומים בתחתיתם, דבר שעלול לגרום לחדירת מים ולרטיבות כתוצאה מעל הפנלים , לכלוך ופגיעה בעמידות הדלת.
נדרש:
1. איטום תחתית מלבני הדלתות באמצעות חומר איטום מתאים.
2. ווידוא איטום איכותי ואסתטי למניעת חדירות עתידיות.

## טרם בוצע התקן עומר (פתח למזגן ממ"ד)/ не установлен омер

ליקוי: טרם בוצע התקן עומר, שהוא למעשה תשתית להתקנת מזגן בממ"ד.
נדרש: יש להתקין עד ליום המסירה.

## חסר ארון למחלק מים / Отсутствует арон для мирказият маим

ליקוי: חסר ארון למחלק מים.
נדרש: להתקין.

## חסר כיור/Нет раковины (киера)

ליקוי: חסר כיור.
נדרש: להשלים ולהתקין כיור.


## אותר סדק /  Трещина

ליקוי: אותר סדק .
נדרש: לבצע תיקון של הסדק.
הערה: במידה וסדק יחזור יש לפנות למהנדס קונסטרוקטור על מנת לבחון את הסיבה לסדיקה.





## מתג  עקום/ выключатель/метег уст. криво

ליקוי: המתג הותקן בצורה עקומה, דבר הפוגע באסתטיקה.
נדרש: ליישר את המתג ולהתקינו מחדש באופן ישר ומדויק.

## שריטה במעקה מרפסת / Царапины на маакэ балкона

ליקוי:  אותרו סימני נזק (שריטות ו/או פגמים/או קילופים) ע"ג המעקה מרפסת, זאת בניגוד לת"י  4068 חלק 1 סעיף 7.1
"כל המוצרים יהיו שלמים ונקיים, ולא יהיו בהם כל סימנים של פגיעות מכניות"
נדרש: ללטש את המעקה ולתקן את השריטות בצורה תקינה ואסתטית באישורת המזמין.. במידה והתיקון לא יהיה אסתטי, יש לשקול החלפת האלמנט הפגום.

## דלת ממ"ד סגירה קשה / дверь мамада очень тяжело закрывается

ליקוי: דלת הדף של הממ"ד נסגרת בטריקה בלבד והידית ננעלת באופן קשה. הליקוי מהווה פגם בטיחותי מכיוון שבמצב חירום בו אישה או אדם מבוגר יצטרכו לסגור את הדלת ייתכן ולא יצליחו והדלת לא תמלא את תפקידה בהגנת היושבים בחדר האטום במצב חירום. וזאת בניגוד להוראות תקן 4422.2
נדרש: לכוונן את הדלת עד לתפקודה בצורה חלקה.

&nbsp;

## ספרינקר לא צמוד לקיר/ Сплинкер не прилагает к стене

ליקוי: הספרינקלר אינו צמוד לקיר, דבר שעלול לפגוע ביעילות פעולתו ואינו עומד בדרישות התקן.
נדרש: להצמיד את הספרינקלר לקיר בצורה תקנית, לוודא שהוא מותקן בצורה יציבה ובהתאם להנחיות התקן.

## חסר פקק לסתימת קיר/ Нет пкака для стены

ליקוי: חסרים פקקי אבן לסתימת קדחים.
נדרש: להשלים את פקקי האבן החסרים.

## צנרת ביוב עוברת מעל/באדמה בחצר /Наружный биюв на гине над землёй-углубить

ליקוי: צנרת אופקית עוברת בחלקה בגובה העולה מעל פני הקרקע הסופיים ללא כל מעטפת הגנה מבטון ובחלקה בקו גובה אחיד מעל פני הקרקע הסופי במקום בגובה של לפחות 30 ס"מ מתחת לקרקע , וזאת בניגוד להל"ת.
נדרש: הורדת צנרת ניקוז ו/או הגנה ע"י מעטפת בטון בכפוף להנחיית יועץ אינסטלציה.


&nbsp;

## חלודה/ржавчина

ליקוי: אותרו סימני חלודה .
נדרש: להסיר סימני חלודה .

## שקע חשמל הותקנה בקרמיקה במקום קיר טיח/-шека установлена на керамике-часть/кир

ליקוי: שקע חשמל הותקנה חלקית בקרמיקה של הקיר וחלקית באזור הקיר. מדובר בליקוי בלתי אסתטי הפוגע במראה המוגמר של חיפוי הקיר, וזאת בניגוד לכללי המקצוע הטובים המקובלים בענף.
נדרש: להגביא שקע חשמל מעל אזור של קרקמיקה.

## צנרת שוכבת ברצפת מסתור כביסה (אין מעבר מים)/ дренажные трубы лежат на рицпе м.квисы

ליקוי: צנרת מונחת ע"ג הרצפה באופן העלול לגרום לחסימת נתיב ניקוז המים בדרכם לקולט הניקוז, זאת בניגוד לכללי המקצוע הטובים המקובלים בענף.
נדרש: הרמת הצנרת מעל מפלס הרצפה.

## פגמים במסגת ממד/ Плохая покраска машкофа мамада

ליקוי: קיימים פגמים חזותיים במראה מסגרות ממ"ד, וזאת בניגוד להוראות תקן 4422.3.
נדרש: תיקוני פחחות ו/או צביעה ע"י צבע עשיר באבץ בהתאם להוראות המפורטות בתקן 4422.3.



## צבע על ההספרינקלר / Краска на сплинклере

ליקוי: אותרו סימני צבע על הספרינקלר, וזאת בניגוד לתקן 1928 סעיף 3.3.1.
נדרש: להסיר בעדינות את סימני הצבע מהספרינקלר באופן ידני. אם לא ניתן להסירם מבלי לפגוע בתפקוד, יש להיוועץ במומחה ספרינקלרים ולהחליף את הספרינקלר במידת הצורך.



## חוסר בידוד תרמי בצינורות מים חמים / Нет бидуда на трубах гор. воды

ליקוי: לא בוצע בידוד תרמי של צינורות מים חמים.
וזאת בנגוד לתקן 1205 חלק 1 סעיף 2.7 דורש, כי יותקן בידוד תרמי לצינורות מים חמים, כדי להבטיח את השמירת חום מים בדרכם מדוד החימום ועד למתקן התברואה.
נדרש להשלים באופן תקין.

## כנף חלון הדף קשה להזזה / Окно мамада тяжело закрывается

ליקוי: כנף חלון הדף קשה להזזה.
וזאת בנגוד לתקן 4422 חלק 1
נדרש: לכוון את הכנף חלון הדף הנ"ל ולשמן גלגלים.

## סגירת חלון ממ"ד קשה מאוד/Тяжелое закрытие окно мамада (холон битахон)

ליקוי: נדרש כוח רב לסגירת חלון ממ"ד, דבר המהווה סכנה בטיחותית ואינו עומד בתקן 4422 חלק 2 סעיף 4.6.
נדרש: נדרש לכוון בצורה מקצועית עד להפעלה תקינה וחלקה.

## תעלת האוויר  הותקנה לא לפי התוכנית/ воздуховод/кубиет гевес не по плану

ליקוי: תעלת האוויר בחדר שינה הותקנה לא לפי התוכנית.
נדרש:
1. פירוק תעלת האוויר הנוכחית.
2. תיקוני טיח וצבע בתקרות וקירות בפרוזדור ובחדר השינה
3. מילוי, תיקון ואטימה של הפתח בקיר החיצוני.
4. קידוח פתח בקיר חיצוני בחדר השינה השני.
5. הרכבת תעלת אוויר חדשה, כולל:
א'. התקנת התעלה
ב'. ביצוע סינר גבס.
ג'. תיקוני גמר כולל שפכטל וצבע.
ד'. התקנת תריס מתאים בקיר המרפסת על קצה התעלה.

## מרחק בין קיר לכיור מעל/פחות מ 40 ס"מ / Расстояние от стены до киёра больше/меньше 40 см

ליקוי: מרחק של ציר הכיור מפני הקיר הינו כ - ______ ס"מ, במקום לפחות 40 ס"מ כקבוע בהל"ת.
נדרש: הזזת הכיור למרחק 40 ס"מ מפני הקיר בהתאם להל"ת.


## אין גישה לפתחי ביקורת מתחת לאסלה/ Нет доступа к смотровым люкам под унитазом

ליקוי: אין גישה לפתחי ביקורת מתחת לאסלה (פתח סגור) על ידי קרמיקה, במקרה זה יש צורך בפירוק אריח לצורך גישה, , וזאת בניגוד להל"ת.
נדרש: פירוק קרמיקה על מנת לאפשר גישה לפתח ביוקרת.


## גמר לקוי / Плохой финиш

ליקוי: באזור המתואר בצילומים שלהלן אותר גימור טיח בלתי אסתטי ו/או פגום ו/או חסר ו/או לא גמור, וזאת בניגוד להוראות לתקן 1920.2
נדרש: תיקוני טיח ו/או שפכטל ו/או צבע עד לקבלת מראה אחיד ואסתטי.

## קופינג חלון בלי ברגים/ нет мех. крепежа копинга

ליקוי: אבני חיפוי סף החלון (קופינג) בוצעו ללא קיבוע בברגים, וזאת בניגוד להוראות תקן 2378.4 ו/או תקן 2378.5.
נדרש: עיגון אבני קופינג בברגים על פי הוראות תקן 2378.4


&nbsp;

## חסר פס מתחת למעקה / Мааке балкона - нет наружной прижимной планки

ליקוי: חסר פס כיסוי בתחתית בית אחיזה בצד החיצוני של המעקה, וזאת בניגוד לכללי המקצוע טובים המקובלים בענף.
נדרש: התקנת פס כיסוי.

## ברגים מגנטים/ крепеж алюм.(окна/витрина) магнитный

ליקוי: עיגון רכיבי מוצרי האלומיניום (חלונות ו/או וויטרינה) בוצע באמצעות ברגיי פלדה מגנטית, וזאת בניגוד להוראות לתקן 1068.1.
נדרש: החלפת בברגיי עיגון העשויים פלדה בלתי מגנטית.


## חסר פרופיל חיצוני בחלון ממ"ד/ Окно мамада отсутствует наружная планка миврешет

ליקוי: חסר פרופיל זוויתן עם מברשת בקו מעבר התריס דרך הגליף, וזאת בניגוד לכללי המקצוע טובים המקובלים בענף.
נדרש: השלמת פרופיל זוויתן עם מברשת.


## ניקוז במסתור כביסה בולט מעל הרצפה (כשל שיפוע)/ Никуз мистор квисы выпирает над полом

ליקוי: ניקוז במסתור כביסה בוצע באופן הבולט ביחס לפני הריצוף ובכך מהווה מצב של הצטברות מים מהווה מצב של הצטברות מים עומדים ובלתי מנוקזים, וזאת בניגוד לכללי המקצוע הטובים המקובלים בענף.
נדרש: תיקוני צנרת להתאמת פרט צנרת ניקוז בעל מכסה רשת המורכב בקו אחיד ביחס לפני הריצוף.

## חסר שלט במסתור כביסה / Нет шелета в м.квисе

ליקוי: חסרה תווית אזהרה למסתור ברוחב 20/10  עם הוראות בטיחות, וזאת בניגוד להוראות תקן 5100.
נדרש: התקנת תווית אזהרה כאמור.

&nbsp;

## חסר צינור ניקוז של הדוד (פורק לחץ) /  Никуз - цинор дуда отсутствует (порек лахац)

ליקוי: חסר צינור ניקוז של הדוד.
נדרש:להתקין את צינור הניקוז ולחבר אותו  לנקודת הניקוז ברצפה.

## חסר ברז למדיח כלים / Нет крана для медиах келим (посудомойки)

ליקוי:  חסר ברז למדיח כלים.
נדרש: להתקין ברז למדיח כלים.

## לא הותקנה וונטה/ Не установлена вента

ליקוי: טרם הותקן וונטה חשמלית .
נדרש: להתקין וונטה בכל חדר שרות/חדר רטוב אשר אין בו פתח אוורור חיצוני על פי התקן.

## מנעול הדלת התקנה הפוכה / Замок двери  обратная установка

ליקוי: אותרה התקנה לקויה (הפוכה)  של מנעול הדלת .
נדרש: להתקין מחדש בצורה תקינה.

## חסרה רוזטה בספרינקלר/ Нет розеты на спринклере

ליקוי:חסרה רוזטה בספרינקלר, דבר הפוגע בגימור האסתטי ועלול להוות סטייה מהתקן לעניין מיקום והתקנה תקנית של הספרינקלר, בניגוד לדרישות ת"י 1928.
נדרש: להתקין רוזטה תואמת לסוג הספרינקלר, בהתאם לדרישות התקן והגימור.

## חסר אף מים / нет аф маима

ליקוי: חסר אף מים.
זאת בניגוד למפרט הכללי הבין משרדי לבניה,סעיף 100512 ובניגוד לת"י 1752 חלק 1 סעיף 3.2.1
נדרש: לחרוץ בדיסק בכדי לקבל אף מים לניקוז אנכי תקין ולמנוע חדירת המים לקירות.

## פנל שבורה/ битая панель

ליקוי: פנל שבורה, וזאת בניגוד לתקן 1555 חלק 2 וחלק 3.
נדרש:  להחליף פנל שבורה לפנל חדשה.

## תיפקוד ידית דלת  לא תקין / Ручка двери не исправна

ליקוי: תיפקוד ידית דלת  לא תקין.
נדרש: לתקן ו/או להחליף את ידית הדלת בהתאם לצורך.

## חסרה קרמיקה במטבח - Отсутствует керамика в митбахе

ליקוי:  לא הותקנה קרמיקה במטבח, וזאת בניגוד לפרט טכני.
נדרש: להשלים קרמיקה לפי מפרט טכני.

## חסרה רוזטה בברז / Отсутствует розета на кране

ליקוי: חסרה רוזטה בברז, דבר הפוגע באסתטיקה ועלול לאפשר חדירת מים או לכלוך.
נדרש: להשלים את הרוזטה ולהתקינה בצורה אסתטית ותקנית.

## לא הותקן צוקל / Не установлен цокель

ליקוי: צוקל המטבח לא הותקן, דבר הפוגע באסתטיקה ובגימור הכללי של המטבח.
נדרש: התקנת צוקל מתאים לאורך הארונות, תוך התאמה לצבע ולעיצוב הקיים.

## במסגרת ויטרינה חסרים אטמי שערות / В крыльях витрины нет тканевого уплотнения

ליקוי: באופן חלקי חסרים אטמי השיערות במסגרת כנפי הוויטרינה.
נדרש: להסיר חלקי האטמים ממסגרת הכנפיים ולהרכיב אטמים שלמים ותקינים.

## ריצוף דירתי בולט מתחת לדלת כניסה / Плитка под дверью выпирает в лоби

ליקוי: מעבר המודרג מתחת לפלדלת בוצע בצורה אלכסונית ולא מקביל לכנף. כתוצאה מכך ריצוף הפנים פולש החוצה, אל התחום של הלובי קומתי.
נדרש : לבצע תיקוני ריצוף - ליישר קו של מעבר המודרג.


## לא נבדקו מידות הדירה בגלל שלא היה תוכנית דירה ביום הבדיקה / В день проверки не проверены размеры квартиры из за отсутствия чертежей

הערה: לא הוצגה תוכנית המכר של הנכס כך שלא היה ניתן להשוות בין המידות רשומות למידות הקיימות.

## צביע לקויה של צנרת מכבי אש / Покрасить в красный цвет цинор эш

ליקוי: צביע לקויה של צנרת מכבי אש.
נדרש:  לבצוע בצבע אדום.


## חסרים מכסים בקופסאות ביקורת / Не установление михсим на куфсаот бикоретах

ליקוי: חסרים מכסים בקופסאות ביקורת ו/או קולט ניקוז.
נדרש: להשלים.

## מתקן חניה אוטומטי לא נבדק/ подъемник парковки автоматический

הערה: מתקן חניה אוטומטי/ הידראולי לא נבדק.
יש לבדוק אותו ע"י גורם מקצועי מוסמך ומורשה לבדיקות מסוג זה בלבד.
הבדיקה מסוג זה אינה במסגרת בדק בית שגרתי.

## התקנת תקרת גבס לא תקינה באזור תעלות האוויר של הממ"ד/ нарушен монтаж гевес воздуховода мамад 

ליקוי: התקנת תקרת גבס לא תקינה באזור תעלות האוויר של הממ"ד.
נדרש: חתוך את התקרת גבס כדי לנקות את פתחי תעלות האוויר הממ"ד.


## קצה חופשי של מאחז יד מותקן באוויר ללא תמיכה / не закреплен конец перил

ליקוי:קצה חופשי של מאחז יד מותקן באוויר ללא תמיכה.
נדרש: הוספת אלמנט תמיכה אנכי.

## רוזטות של עמודי מעקה לא צמודים לפני הקופינג /упоры (розеты) в ограждении не закреплены и не опущены на  копинг

ליקוי: רוזטות של עמודי מעקה לא צמודים לפני הקופינג.
נדרש: הצמדת רוזטות.

## לא הורכב מחסום רוח צדדי על כיס החלון / Открытая ниша в халон мамаде

ליקוי: לא הורכב מחסום רוח צדדי על כיס החלון.
נדרש: להשלים התקנה.

## אוורור לא מתוכנן בחדר שינה/ кубиет гевес венты не по плану

ליקוי: האוורור של _______  מתבצע ע"י וונטה, כאשר תעלת האוויר של הונטה עוברת בתוך סינר הגבס צמוד לתקרה וקיר של _______   . מידות הסינר לתעלת האוויר אשר קוטרה כ 3-4 צול סה״כ לא מתאימות ומופרזות לחלוטין. בנוסף בסינר זה נוצר קטע אשר מהווה הנמכה נוספת והופחת את גובה החדר מתחתיה לבלתי תקני. בנוסף סינר זה לא מופיע בתכנית המכר של הדירה .
נדרש:
א'. לפרק את הסינר במלאו ולבצע מחדש. כאשר מידות הסינר החדש יהיו מינימליות בהתאמה לגודל של תעלת אוויר , וזאת בצורה אחידה וללא הנמכות נוספות.
ב'. בנוסף מומלץ יעוץ עם שמאי לגבי קיום הסינר הלא מתוכנן בחדר שינה.

## צנרת כיבוי אש לא צבוע בצבע אדום/ трубы пожаротушения не покрашены

ליקוי: צנרת כיבוי האש אינה צבועה בצבע אדום.
נדרש: צביעת צנרת כיבוי האש בצבע אדום תקני, למטרת זיהוי ברור ושמירה על דרישות הבטיחות.

## ניילון בדלתות/найлон на дверях

הערה: דלתות הדירה נבדקו כאשר הן עטופים ע"י ניילון. לקראת מסירת הדירה יש להסיר את העטיפה ולבדוק את הדלתות שנית.
במידה וימצאו ליקוים יש לתקנם בהתאם.

## מחסן וחניה לא מוכנים לבדיקה/ махсан и ханоя не готовы к осмотру

הערה: לפי דברי הקבלן מחסן וחניה לא מוכנים לבדיקה.

## סף האלומיניום של החלון רופף / Алюминиевый подоконник шатается

ליקוי: סף האלומיניום של החלון לא מקובע היטב, מתרומם ורופף.
נדרש: לקבע סף האלומיניום.

## ניילון כללי/ двери, окна Найлон

הערה: לפני מסירת הדירה יש להסיר את עטיפת הניילון ממעקה ו/או דלתות ו/או חלונות. יש לבדוק תקינות ושלמות, במידה וימצאו ליקוים יש לתקנם בהתאם.

## לולאה/монтажная петля

ליקוי: אותרה לולאה להרכבה בקיר.
נדרש: לפרק את הלולאה ולהשאיר את הקיר חלק.

## חסר מכסה לארון תקשורת/ отсутствует крышка шкафа связи

ליקוי: חסר מכסה לארון תקשורת.
נדרש: להשלים.

## חלון ממ"ד תפקוד לקוי/ Окно мамада не исправно

ליקוי: חלקי בריח נעילת ביטחון של חלון ממ"ד לא מתפקד כראוי.
נדרש: שחרור ו/או ניקוי א/או כיוון ו/או התאמת חלקי הבריח עד למצב תפקוד כיאות.


## תפקוד שקע לא תקין / Шека не работает

ליקוי:תפקוד שקע לא תקין.
נדרש: לבצע בדיקת מערכת חשמל ע"י חשמלאי מוסמך ולבצע תיקונים הנדרשים על פי תוצאות הבדיקה.

## מנעול זמני / временный замок двери

ליקוי:בדלת הכניסה מותקן מנעול זמני.
נדרש: יש להחליף אותו במנעול קבוע.

## סדק קונסטרוקטיבי

ליקוי: אותר סדק .
נדרש: לבצע תיקון של הסדק.
הערה: במידה וסדק יחזור יש לפנות למהנדס קונסטרוקטור על מנת לבחון את הסיבה לסדיקה ולבצע תיקון בהתאם להמלצות המהנדס.





## גובה קופסות ביקורת לא תקינה / Завышенная куфсат бикорет

ליקוי: גובה קופסות ביקורת לא תקינה.
נדרש:לבצע חיתוך קוספת ביקורת עד מפלס הרצפה.

## לא הותקן תריס בחלון / Не установлен трис

ליקוי: טרם הותקן תריס בחלון .
נדרש: להתקן תריס.

## חסרי אטמי השיערות במסגרת חלון ממ"ד / Волосинные уплотнения триса мамада

ליקוי: חסרים אטמי השיערות במסגרת כנפי תריס
נדרש: להתקין אטמי השיערות במסגרת כנפי תריס.

## חסר חלק עליון פס וויטרינה

ליקוי: חסר חלק עליון של הלבשת הוויטרינה, וזאת בניגוד להוראות תקן 4068.1
נדרש: להשלים הרכבת הלבשה.

## רוזטות לא צמודות לקיר

ליקוי: רוזטות לא צמודות לקיר.
נדרש: להצמיד את הרוזטות לקיר בצורה תקינה.

## חסר סטופר לחלון תריס חשמלי /   Стопер для низа трис хашмали окно

ליקוי: בתריס חשמלי של החלון לא הורכב  מעצור לתריס גלילה.
חובה להתקין את המעצר על מנת למנוע בליעת התריס אל תוך הארגז.
נדרש:  להתקין מעצור לתריס גלילה.

## חסר גלאי עשן / Нет галай ашан

ליקוי: חסר גלאי עשן.
נדרש:  להתקין גלאי עשן.

## חסרה נקודת ניקוז במסילת חלון ממ"ד/ Отсутствие дренажных отверстий с халоне мамада

ליקוי: במסילת תריס של חלון ממ"ד לא אותרו אמצעי ניקוז (פתחים). בגלל זה בתחתית משקוף הפלדה נוצר קטע ללא ניקוז מי גשם.
הדבר יגרום להצטברות מים, עליית המים, חדירת המים אל תוך כיסי החלון ויתכן שיצרו רטיבות בקירות באזור החלון.
נדרש: לבצע אמצעי ניקוז במסילת התריס התחתונה.

## מסילת תריס רופפת (לא יציבה) / Крепеж витрины шатается

ליקוי: מסילת תריס לא יציבה.
נדרש: לבצע קיבוע מכני תקני של מסילות התריס לגליפים.

## כיור שקע במטבח / Киер просадка с шаишом

ליקוי: כיור המטבח הורכב על פני השיש בצורה לא מקצועית ולא אסתטית. הכיור שקוע מעט בתוך השיש וזה טבעי, איך עומק ה"שקע" משתנה ממקום למקום, והדבר בולט לעין ומהווה פגם אסתטי .
נדרש: לפרק את הכיור ולהתקינו מחדש באופן מקצועי ואסתטי, תוך הקפדה על ייצור שקע שווה במידה סביב הכיור.

## פינת מטבח (פתרון פינה) לא בשימוש / Угловое решение карусель выдвижная в митбахе

ליקוי: בניגוד למפרט הדירה,וגם המפרט הכללי למחיר למשתכן בארון הפינתי לא הורכב "פתרון פינה" לצורך מתן אפשרות להגדלת שימוש בארון הפינתי באופן מקסימלי.
נדרש: להתקין מתקן של "פתרון פינה".

## מיכל הדחה (אסלה) רופף / Бачок унитаза шатается

ליקוי: מיכל הדחה (ניאגרה) לא מחוזק היטב לאסלה, אינו יציב ומתנדנד.
נדרש: לחזק את מיכל הדחה.

## צנרת קולטנים אינו צבוע בצבע לבן (צינור ביוב וורטיקאלי) / Биюв в мистор квисе не покрашен в белый цвет

ליקוי: צנרת קולטנים אינו צבוע בצבע לבן.
נדרש: לצבוע בצבע לבן.

## דוד עקום / Дуд криво установлен

ליקוי: דוד החשמל הותקן  בצורה עקומה.
נדרש: ליישר את הדוד ולבצע התקנה יציבה ובטיחותית בהתאם לסטנדרטים הנדרשים.

## חסרה גומייה בדלת מחסן / Нет гумии на двери махсана

ליקוי:בהיקף כנף הדלת מחסן לא הותקן אטם גומי.
נדרש:להשלים התקנת אטם גומי בהיקף הדלת כדי להבטיח אטימה תקינה.

## ארון כיבוי אש בחניית הלקוח / Арон кибуй эш на паркове клиента

ליקוי: מיקום עמדת כיבוי אש בוצע בתוך תא חניה פרטית. הדבר יוצר מצב של הפרעה בשימוש העמדה בזמן שהמכונית חונה.
נדרש: שינוי מיקום ו/או קבלת אישור הסוגיה ע"י יועץ בטיחות בכיבוי אש.
הערה: עלות משוארת של העברת עמדת כיבוי אש, מחיר סופי יקבע יועץ בטיחות.

## פינות דלתות גימור לקוי / кант двери ликуй

 ליקוי: גימור לקוי בכנפי הדלת.
מדובר על התקנת קנטים לקויה ולא אסתטית בדופנות של הכנפיים.
נדרש: לבצע תיקון בדלת באזור הקנטים .

## ידית הדלת עקומה / Кривая ручка двери

ליקוי: ידית הדלת עקומה.
נדרש: להתקין מחדש.

## חומר גמיש לקוי / роба гмиша лакуя

ליקוי: בוצע מריחת חומר גמיש בצורה לקויה ולא אסתטית.
נדרש: להסיר את החומר הגמיש וליישם חומר גמיש בצורה אסתטית.

## חוסר איטום בין שיש (קופינג) לקיר במרפסת / итум копинг стена мирпесет

ליקוי: לא בוצע מישק הפרדה במפגש שיש (נדבך ראש של מעקה מרפסת) וחיפוי הקיר.
נדרש: יש למלא בצורה תקינה (בעובי של 4 מ"מ לפחות) ומקצועית את מישקי האבן למניעת חדירת רטיבות.

## סימון זכוכית מרפסת / симан текена стекло мирпесета

ליקוי: לא סומנה זכוכית במעקה מרפסת וזאת בניגוד לדרוש בתקן 1099.
נדרש: להרכיב זכוכית בטיחותית בהתאם לתקן 1099 חלק 1.1


## דלת ממ"ד נפתחת כלפי פרוזדור (אין מעבר תיקני מעל 18ס"מ) /  Дверь мамада нет прохода

ליקוי: דלת ממ"ד נפתחת כלפי פרוזדור הדירה, כתוצאה מכך היא חוסמת את המעבר החופשי בפרוזדור ומהווה ליקוי בטיחותי המפריע בחיי היום יום.
כמו כן במצב פתיחה מקסימלי דלת ממ"ד פוגעת בפנל הריצוף ואינה נפתח בצמוד לקיר.
נדרש: להמציא פתרון ראוי, יעיל לבעיה המתוארת.
הערה: יתכן ויהיה צורך בהחלפת דלת הממ"ד לדלת הזזה לרבות כל העבודות המבניות הנדרשות. במידה והתיקון לא יתוקן, נדרש לבחון מול שמאי מקרקעין ירידת ערך לדירה.
בשלב זה  מתמחר עלות התיקון.


## מלבן (משקוף) דלת  ממ"ד  צביע לקויה / Машкоф  мамада краска

ליקוי: משקוף הממ"ד נצבע בכיסוי שאינו מלא ואחיד.
נדרש שמשקוף הממ"ד יצבע בכיסוי מלא ואחיד, וללא פגמים.

## חסר מכסה / нет михсе

ליקוי: חסר מכסה או רשת לפתח הניקוז, מה שעלול לגרום לסתימות ולהצטברות לכלוך.
נדרש: להשלים את המכסה או הרשת לפתח הניקוז בצורה תקנית שתמנע חדירת לכלוך ותאפשר ניקוז יעיל.

## חסר ראש מקלחת (דוש) / Душ нет лейки

ליקוי: חסר ראש מקלחת (דוש).
נדרש: להתקין ראש מקלחת.

## סף חלון הותקן עם שיפוע הפוך / Подоконник окна установлен с плохим уклоном

ליקוי: סף חלון הורכב עם שיפוע נגדי - כלפי החלון. ליקוי זה יגרום לחדירת מים אל תוך הדירה ולייצור רטיבות מתחת לחלון.
נדרש: לשנות שיפוע של הסף החלון ולאטום מחדש. למיטב הבנתי התיקון הנ"ל דורש פירוק חלון.

## מכסה דקורטיבי / михсэ (решет) декоративи

ליקוי: טרם בוצע התקנה של מכסה דקורטיבית.
נדרש: להתקין.

## זכוכית מעקה מרפסת רופף /Стекло маакэ мирпесета шатается

ליקוי: זכוכית מעקה מורכבת בצורה רעועה.
נדרש:  לחזק או להחליף את הזכוכית והחיבורים כדי להבטיח יציבות ובטיחות.

## כתמים בכיור / пятна в раковине

ליקוי: אותרו כתמים בכיור.
נדרש: להסיר במידה ואי הצלחה יש להחליף לחדש.





## לא הותקנה ונטה במטבח כפי שדרוש במפרט טכני / Нет венты в в митбахе

ליקוי: לא הותקנה ונטה במטבח כפי שדרוש במפרט טכני.
נדרש: להתקין ונטה לפי דרישת המפרט טכני.





## חניה: רוחב קטן בגלל ארון כיבוי אש

ליקוי: לדירה הנדונה שייכת חניה מס' ____ המתוארות בתמונה שלהלן.
בתוך החנייה מותקן ארון כיבוי אש, בגללו אורך החנייה עומד על ____ מ' במקום לפחות 5 מ', וזאת בניגוד להנחיות תכנון חניות של משרד התחבורה.
נדרש:
1. לבצע הרכבת מעצורי חניה, בכדי לא לאפשר לרכב להתקרב לארון ובכך למנוע פתיחתו וגם שימוש בו.
2. להזיז סימון החניה אחורה למרחק ששווה עומק הארון.
לחלופין יש לבצע בדיקת הסוגיה ע"י יועץ תנועה ו/או זימון שמאי מקרקעין





## אריחים רזרביים :_______

בוצעה בדיקה חלקית של מלאי הריצוף שנמצא בממ"ד (רזרבה לצורך תיקונים עתידיים). ובשלב זה תוצאותיה הן:

## לחץ מים חלש בדירה - Низкое давление воды

הערה: ביום הבדיקה לחץ מים בדירה היה חלש. חשוב לציין שבניין והדירה טרם מחוברים למשאבות. במידה ואחרי אכלוס לדירה לחץ מים עדיין תהיה חלש מומלץ לפנות לקבלן לטיפול הבעיה.





## דלת חדר רחצה לא מתאימה/ Двери не влагостойкие

הערה: על פי הסימון שנמצא על של חדר רחצה הורים וחדר רחצה כללי (אמבטיה), דלת זו אינה מתאימה לשימוש בחדרי הרחצה.
נדרש:  בדיקה מול ספק הדלתות ו/או קבלן תקינות הדלתות.
אם יתגלה שהדלתות אינן מתאימות לחדרי הרחצה, יש להחליפן.
ללא עלות כרגע.

## דלת ממ"ד חלולה/Пустота в двери мамада

ליקוי: משני צדי כנף הדלת פח הכנף לא יציב ורופף באופן מופרז. הדבר מעיד על כשל כלשהו ביצור הדלת.
נדרש: יש לבצע בדיקה ע"י גורם מוסמך או וזאת עדיף ע"י מעבדה מוסמכת.
במידה וכנף הדלת אינה עומדת בדרישות התקן יש להחליפה לכנף חדשה ותקינה.

## אין רשתות בחלונות / Нет решетов на окнах

ליקוי: טרם הותקנו רשתות בדירה.
נדרש: להשלים לפי הזמנת הלקוח.
ללא עלות כרגע





## התקנת עומר (מזגן ממ"ד) בוצע בצורה לא תקינה (פחות מ 20ס"מ מהתקרה) / Никуз мазгана мамада нет 20 см

ליקוי: התקנת עומר בוצע בצורה לא תקינה .
נדרש:
1. להעביר את העומר לגובה תקין (20 ס"מ)
2. להתקין עומר מיוחד באחד מצינורות האוויר מעל הדלת ולשלם פיצוי כספי על עבודות הנוספות הקשורות לזה, כגון תקרת גבס וכו'.





## חסר פס הפרדה במרפסת / Нет пас афрады в мирпесете

ליקוי: לא הותקן סף מתכת (פס הפרדה) עשוי פליז או אלומיניום כמקובל במשק הפרדה שבין אריחי קרמיקה ברצפת  מרפסת .
נדרש:
1. לבצע בדיקת תקינות מערכת האיטום.
2. להתקין סף אלומיניום במפתן הדלת בתפר בין הריצופים .
ללא עלות כרגע




## חסר פרופיל חיצוני של החלון /Нет наружного профиля окна

ליקוי: חסר פרופיל חיצוני של החלון.
נדרש: להשלים.

## ויטרינה עקומה (סטייה מהמישוריות) - Кривая витрина

ליקוי: ויטרינה נמצאה בסטייה מהמישוריות, זאת בניגוד לתקן 4068 סעיף 7.1
המלצה נדרש לפלס כנף הויטרינה ולוודא מקביליות להלבשות האלומיניום ולכנף התואמת.
נדרש: המלצה נדרש לפלס כנף הויטרינה ולוודא מקביליות להלבשות האלומיניום ולכנף התואמת.

## חיפוי האמבט בולט מהקרמיקה / Керамика стенки амбатии выпирает

ליקוי: חיפוי האמבט בולט מהמישור.
נדרש: יש להתקין אריחים בצורה מקצועית וישרה.

## חנייה לא תקינה / Ханая маленькая

ליקוי: מידות החניה אינן עומדות בתקן, וזאת בניגוד לתקן 1918.
הערה:
רוחב:
חניה חופשית: 230 ס"מ
חניה עם עמוד/קיר מצד אחד: 255 ס"מ
חניה עם עמוד/קיר משני הצדדים: 280 ס"מ.
אורך:
חניה מול קיר, או עצם קשיח אחר: 500 ס"מ
חניה בשטח חופשי: 475 ס"מ
חניה מול אבן שפה (כש 50 ס"מ חופשיים מעבר לאבן): 425 ס"מ
גובה חניה מינימלי: 220 ס“מ
נדרש: לקבל הבהרות לגבי חניה שאינה במידות התקן ולהמציא פתרון מוסכם לליקוי הנ"ל.

## ריצוף/קרמיקה : ביום הבדיקה לא נמצאו ליקוים מהותיים.

ריצוף/קרמיקה: ביום הבדיקה לא נמצאו ליקוים מהותיים.

## שלד \ קונסטרוקציה - תקין

 שלד \ קונסטרוקציה: בקירות החוץ , בקירות הפנים ובתקרות חדרי הדירה לא נמצאו סדקים אלכסוניים קונסטרוקטיביים, סימני שקיעה, סימני הפרדה בין האלמנטים של השלד וכדומה. שלד הדירה (הבניין בתחום הדירה) נמצא תקין. בשלב זה אין חשש על יציבות המבנה.

## טיח וצבע פנים - תקין

טיח וצבע פנים: באופן כללי מצב הטיח בקירות ותקרות הדירה סביר.

## אלומיניום - תקין

אלומיניום: ביום הבדיקה לא נמצאו ליקוים מהותיים.

## נגרות - תקין

נגרות: מצב של רוב הדלתות, ארונות המטבח ורהיטים אחרים קבועים סביר.

## בטיחות - תקין

בטיחות: לא נמצאו ליקוים מהותיים.

## חשמל - תקין

חשמל: לא נמצאו ליקוים מהותיים.

## ריצוף בדירה עקום מעל 4 מ"מ / Кривой пол разница  больше 4 мм

ליקוי: סטיות מקומיות במישוריות פני הריצוף- בבדיקתי נמצאה סטייה העולה על 4 מ"מ, וזאת בניגוד לתקן:
תקן 1555 חלק 3 גיליון תיקון מס 1 מינואר 2014 סעיף 5.1.4.1.2
תקן 1555.3 חלק 3 גיליון תיקון מס 1 מינואר 2014 סעיף 3.2
נדרש: יש לפרק את האריחים המסומנים ולהתקין באופן מפולס ומישורי ללא סטיות.
&nbsp;






## חלון לא ניתן להוציא / Холон - окно не возможно снять

ליקוי: בניגוד לדרישת התקן 1068 חלק 1 (ראה ציטוט להלן) חלון לא ניתן לפרק את הכנפיים (אגפים).
נדרש: להחליף את הכנפיים, אשר מידותיהן / גובה תאפשר פירוק תקין וקל במקום המסילה אשר מוגדר בתקן.


## תפקוד ו/או התקנה של ______ בוצע בצורה לקויה / Функция установка _____ дефектная

ליקוי: תפקוד ו/או התקנה של ______ בוצע בצורה לקויה.
נדרש: לבצע תיקון הנדרש על מנת להביא למצב תקין.


## ספרינקלר לא צמוד לתקרה/ Спринклер не прилагает к потолку

ליקוי: הספרינקלר אינו צמוד לתקרה, דבר שעלול לפגוע ביעילות פעולתו ואינו עומד בדרישות התקן.
נדרש: להצמיד את הספרינקלר לתקרה בצורה תקנית, לוודא שהוא מותקן בצורה יציבה ובהתאם להנחיות התקן..

## ניילון על האמבטיה / Найлон в хибуре амбатии

ליקוי: ניילון ההגנה לא הוסר מהאמבטיה, ואיטום בוצע מעל הניילון. מצב זה עלול לגרום לחדירת מים בעתיד, מכיוון שהניילון מונע הצמדות נכונה של חומר האיטום לאמבטיה. כתוצאה מכך, ישנה סבירות גבוהה לחדירת מים לרצפה ולגרימת רטיבות ונזקים מצטברים.
נדרש: להסיר את ניילון ההגנה ולבצע איטום מחדש בצורה תקינה וישירה על פני האמבטיה.

## קנט התקנה לקויה / Кант острый и дефектный

ליקוי: התקנת הקנט בוצעה בצורה לקויה והוא חד, דבר העלול לגרום לפציעות ולבעיות אסתטיות.
נדרש: לפרק ולהתקין מחדש את הקנט באופן מקצועי, כך שיהיה חלק ובטוח לשימוש.


## צינור בולט חוסר ניקוז ברצפת מסתור הכביסה / Труба торчит нет никуза в мистор квисе

ליקוי: טרם בוצע ניקוז ברצפת מסתור הכביסה, מצב העלול לגרום להצטברות מים.
נדרש: לחתוך את הצינור וליצור נקודת ניקוז ברצפת מסתור הכביסה.


## גמר סביב הספרינקלרים בוצע בצורה לא אסתטית / Сплинкер цева вокруг

ליקוי: הגימור סביב הספרינקלרים בוצע בצורה לא אסתטית, והספרינקלרים עצמם אינם ממוקמים בצורה ישרה.
נדרש: ליישר את הספרינקלרים ולהתקין מחדש את הגימור סביבם באופן אסתטי ומדויק.

## חשד לחוסר איטום באינטרפוץ

ליקוי: קיים חשד לחוסר איטום פנימי מאחורי כיסוי  ברז אינטרפוץ, מה שעלול לגרום לחדירת מים ורטיבות בקיר.
נדרש: לפרק את כיסוי הברז, לבדוק את מצב האיטום הפנימי ולבצע איטום מחדש במידת הצורך.

## חיתוך אריח סביב סיפון לא אסתטי / Подрезка плитки вокруг сифона

ליקוי: חיתוך האריח סביב הסיפון בוצע בצורה לא מקצועית, מה שיצר חור שאינו אסתטי.
נדרש: להחליף את האריח או למלא את החור בצורה אסתטית ומקצועית.

## שריטה בזכוכית הוויטרינה / Царапина на стекле витрины

ליקוי: אותרה שריטה בזכוכית הוויטרינה, אשר פוגעת באסתטיקה של הדירה ועלולה להחמיר עם הזמן.
נדרש: לבדוק אפשרות ללטש את השריטה במידה והיא שטחית. אם לא ניתן להסיר את השריטה על ידי ליטוש, יש לשקול החלפת הזכוכית על מנת להחזיר את המראה האסתטי.
הערה: אם יידרש להחליף את הזכוכית, העלות עשויה לנוע בין 1,500-3,000 ש"ח, תלוי בגודל הוויטרינה וסוג הזכוכית.

## פגמים במשקוף דלת הכניסה / Машкоф делет книса вмятины

ליקוי: פגמים במשקוף דלת הכניסה לדירה.
נדרש:
1. שיוף ותיקון האזורים הפגומים במשקוף.
2. יישום שכבת צבע חדשה ואחידה כדי להבטיח מראה אסתטי והתאמה לשאר המשקוף.
הערה: במידת הצורך, החלפת חלקים פגומים במשקוף אם השיוף והתיקון אינם מספיקים.

## כיור עקום / Киер криво установлен

ליקוי: הכיור הותקן בצורה עקומה ואינו מפולס, וזאת בניגוד לתקן ישראלי ת"י 1205 חלק 3, סעיף 2.2.1.
נדרש: ליישר ולהתקין מחדש את הכיור באופן מפולס ומדויק.

## מעקה מרפסת מרווח פתוח / пина мааке соосность

ליקוי: חיבורי המעקה הותקנו בצורה לא אחידה, דבר היוצר מרווחים הפוגעים באסתטיקה ועלולים להוות סיכון בטיחותי.
נדרש: ליישר ולהדק את חיבורי המעקה באופן מקצועי כדי לוודא שאין מרווחים שאינם עומדים בדרישות התקן.

## מילוי הרובה לא אחיד / пропуски робы и шинуй цева

ליקוי: מילוי הרובה בוצע בצורה לא אחידה, עם חללים ושינויי גוון חלקיים, בניגוד למפרט הכללי – סעיף 10034.
נדרש: לחרוץ את הרובה הקיימת באמצעות כלי ייעודי, לנקות את המישקים, ולבצע מילוי מחדש עם רובה בגוון אחיד, תוך הקפדה על עבודה מקצועית ואחידה.

## צינור אמבטיה שרשורי / Цинор амбатии джакузи

ליקוי: בוצעה צנרת גמישה מסוג "צינור ג'קוזי", אשר לפי צילום במצלמה מהווה חומר שאינו תקני לשימוש בצנרת סמויה באמבטיה. צינור זה אינו מאושר לשימוש, אלא אם כן יוכח כי הוא עומד בתקני ייצור שמוזכרים בתקן 1205.2. בנוסף, צינור "ג'קוזי" אינו תקין כצנרת ניקוז דלוחין בשל צורתו, העלולה לגרום להצטברות פסולת, חיידקים וכדומה.
הערה: צנרת זו אינה עומדת בדרישות התקנים הישראלים החלים עליה, בהתאם לתקן 576 חלק 2, תקן 958 חלק 2 ות"י 4476 חלק 2.
נדרש: להחליף את צינור הניקוז מסוג "ג'קוזי" בצינור העשוי מחומר תקני, בהתאם לדרישות התקן הישראלי.



## דלת חדירת אור / Дверь  свет

ליקוי: דלת אינה אטומה באופן הרמטי וקיים מרווח המאפשר חדירת אור ואוויר.
נדרש: לבצע כיוונון ותיקון לדלת כך שתיסגר בצורה הרמטית ללא מרווחים.
במידת הצורך, להחליף אטמים או רכיבים פגומים במסגרת הדלת.

## לחץ נזילה, צנרת רקובה 25

סיבה: בוצעה בדיקת לחץ למערכת מים. בבדיקה התגלתה ירידת לחץ במערכת מים. ירידת לחץ מאפיינת לנזילה סמויה.
הסבר: סיבת הרטיבות ונפילת לחץ המים היא קורוזיה בצנרת המים הקרים. לאורך השנים, הצנרת צברה קורוזיה וכיום התבקעות הצינור גורמת לרטיבות.
נדרש:
1. להחליף את צנרת המים הישנה בצנרת חדשה ועמידה תחת תו תקן.
2. לבצע פירוק ריצוף מלא לצורך חשיפת הצנרת.
3. להחליף את מצע המילוי הרטוב (חול/חצץ) במצע יבש וחדש.
4. לחדש את שכבת האיטום הרצפתי.
5. לבצע ריצוף מחדש והשבת המצב לקדמותו.

## לחצן עקום / лахцан аслы кривой

ליקוי: לחצן ההדחה בשירותים מותקן בצורה עקומה.
נדרש: יישור והתקנה מחדש של הלחצן כך שיהיה ממוקם בצורה אסתטית ונכונה.

## לוח חשמל לא נסגר (חסר ציר) / пин в луах хашмаль

ליקוי: חסר ציר בדלת ארון החשמל, דבר שגורם לכך שהדלת אינה נסגרת כראוי.
נדרש: התקנת ציר חדש התואם לדלת ולארון, כולל חיזוק ובדיקה שהדלת נסגרת ונפתחת באופן תקין.

## סטיה אי האתרמה (רשימה)

ליקוי: נמדד אורך/רוחב של חללים שונים בדירה עם סטיות ביחס למידות המתוכננות, כדלקמן:
חדר :  ____ ס"מ במקום ____ ס"מ.
הערה: הובהר לרוכשים כי אינני מודד מוסמך ועל כן יתכנו סטיות במדידה זו. המדידה בוצעה לשטח נטו בלבד, ללא חישוב קירות חוץ או פנים, ואין לה תוקף משפטי.
מומלץ:
- לבצע מדידה מדויקת באמצעות מודד מוסמך.
- במידה וקיימת אי התאמה משמעותית מהמותר, לפנות לשמאי מקרקעין לצורך הערכת פיצוי כספי מתאים.

## חסרים פקקים לכיסוי ברגים בארונות המטבח / Пкак хосер в ароне митбаха

ליקוי: חסרים פקקים לכיסוי ברגים בארונות המטבח.
נדרש: התקנת פקקים מתאימים לכיסוי הברגים לשיפור המראה האסתטי.

## אוויר מתחת ליריעה הביטומנית / Воздух под ириет  битум

ליקוי: קיים אוויר מתחת ליריעה הביטומנית בגג, דבר המעיד על חיבור לקוי ועלול לגרום לחדירת מים.
נדרש:


 	לבצע בדיקה מקיפה של היריעות כדי לזהות את כל האזורים בהם קיים כשל בחיבור.
 	להסיר ולהחליף את היריעות הפגומות.
 	לבצע הדבקה מחדש של היריעות הביטומניות תוך הקפדה על איטום תקין.


## מילוי רובה אלסטית בוצע בצורה לא מקצועית / Роба эласти ле эстети

ליקוי: מילוי רובה אלסטית בוצע בצורה לא מקצועית, דבר שעלול לגרום לבעיות אסתטיות וחדירת מים.
נדרש: להסיר את הרובה הקיימת ולבצע מילוי מחדש באמצעות רובה אלסטית מקצועית, להבטחת אטימה ואסתטיקה.

## ידית סגירת חלון  בממ"ד תפקוד לקוי / Ручка холона битахона  тяжелое закрытие

ליקוי: ידית סגירת חלון פלדה בממ"ד מתפקדת בקושי בזמן הסגירה, מה שעלול להשפיע על האטימה והבטיחות.
נדרש: להסיר צבע שהצטבר על המנגנון, לשמן את החלקים הנעים ולכוונן את מנגנון הנעילה כדי להבטיח תפקוד תקין.

## כוחלה גוון  לא אחיד / Кохла шинуй цева на стенах

ליקוי: גוון הכוחלה לא אחיד, מה שפוגע באסתטיקה של החיפוי.
נדרש: הסרת הכוחלה באזור הפגום ומילוי מחדש בגוון אחיד.

## גומייה בדלת ממ"ד צבע / Гумия  с краской на двери мамада

ליקוי: צבע על גומיית האטימה של דלת הממ"ד, דבר שעלול לפגוע בגמישותה ובאטימותה.
נדרש: להסיר בעדינות את הצבע מהגומייה או להחליף את גומיית האטימה במקרה של פגיעה בתפקודה.

## חסר פתח ביקורת מכסה לצינור ביוב / Михсе биюва 4 хосер

ליקוי: פתח ביקורת  לצינור הביוב אינו קיים ו/או לא בוצע כראוי, מה שעלול להקשות על ביצוע תחזוקה ותיקונים בעת הצורך.
נדרש: ליצור פתח גישה תקני בהתאם להנחיות היצרן, כולל כיסוי דקורטיבי נגיש לתחזוקה.

## שיפוע לקוי סביב ניקוז המקלחת / Шипуа никуз миклахат (никудати)

ליקוי: שיפוע לקוי סביב ניקוז המקלחת גורם להצטברות מים עומדים, דבר שעלול להוביל לרטיבות ולמניעת ניקוז תקין.
נדרש: יש לבצע תיקון לשיפוע הרצפה כך שהמים יתנקזו כראוי לכיוון הניקוז.

## רטיבות (תרמי ומד לחות) - תקין / Ративут такин (терми и мад.л)






בדיקה: ביום הבדיקה בוצעה בדיקת הרטיבות באמצעות מצלמה תרמית ומד לחות, ונמצא כי לא קיימת לחות במקום הנבדק.







## לחץ - תקין / Лахац такин






בדיקה:בוצעה בדיקת לחץ מים, ונמצא כי המערכת פועלת באופן תקין וללא סימני נזילה או ירידת לחץ.







## ביוב - תקין / Биюв такин













בדיקה: בוצעה בדיקה למערכת הביוב הדירתית, ונמצא כי המערכת פועלת באופן תקין, ללא נזילות או סתימות.














## מרווח במשקוף/Мирвах машкоф

ליקוי: קיים מרווח בין חלקי המשקוף, דבר הפוגע באסתטיקה ועלול לגרום לחוסר יציבות.
נדרש: למלא את המרווח בחומר מתאים (אלסטומרי) ולוודא חיבור תקין בין חלקי המשקוף.

## כשל איטום סביב ניקוז  מסתור כביסה / Мистор квиса никуз  итум ликуй

ליקוי: קיים חשד לכשל איטום סביב ניקוז רצפת מסתור הכביסה, דבר שעלול לגרום לחדירת מים ולרטיבות במבנה.
נדרש: לבדוק את תקינות האיטום סביב הניקוז, לבצע תיקון ואיטום מחדש במידת הצורך, ולוודא שהמים מתנקזים כראוי.

## חלון  ממ"ד (פלדה) תקועה / Холон битахон застрял

ליקוי: פלדת חלון הממ"ד תקועה ואינה נפתחת כראוי, דבר שעלול לפגוע בתפקוד התקין של החלון במצב חירום.
נדרש: לשחרר את הפלדה, לוודא פעולה תקינה של המנגנון ולשמן במידת הצורך.

## קופינג הותקן בגוון שונה / копинг шинуй цева

ליקוי: הקופינג במרפסת הותקן בגוון שונה, מה שפוגע באחידות העיצובית ובמראה האסתטי של המרפסת.
נדרש: לבדוק מול הקבלן האם מדובר בטעות בהתקנה, ובמידת הצורך להחליף את הקופינג לגוון תואם.

## רעש בזמן פתיחת ברז / Шум при открытии крана, интерпуца

ליקוי: בעת פתיחה וסגירה מהירה של ברזי המים נשמעים רעשים חזקים של נקישות מתוך הקירות. מדובר בהלם מים, הנגרם מתזוזת הצינורות עקב שינוי פתאומי בלחץ המים, בניגוד להל"ת סעיף 2.8.2. מצב זה עלול לגרום לרעידות, קפיצת הצינור ואף לנזקים מבניים בצנרת.
נדרש: לפרק את אריחי החיפוי, לחשוף את צנרת אספקת המים ולבצע קיבוע וחיזוק הצנרת בצורה תקנית, כולל עיגון בכניסה לאינטרפוץ.

## שיפוע ריצוף לכיוון אמבטיה לקוי / Шипуа от стены в сторону амабтии лакуй

ליקוי: שיפוע הריצוף באזור האמבטיה לקוי, מה שגורם להצטברות מים במקום להתנקז כראוי.
נדרש: לפרק את הריצוף באזור האמבטיה ולבצע ריצוף מחדש עם שיפוע תקין לכיוון האמבטיה.

## גובה אמבטיה לקוי צריך להיות בין 40-60 ס"מ / Высота ванны должна быть в пределах 40-60 см

ליקוי: קיימת סטייה חריגה ממידות מקובלות ומומלצות לגובה האמבט ביחס לגובה פני הריצוף.
בבדיקת האמבט נמצא כי גובה המפלס העליון של האמבט מפני הריצוף הוא ___ ס"מ, וזאת בניגוד להנחיות תקן 1205 חלק 3 סעיף 3.3, המפנה לתקן 1205 חלק 2 סעיף 3 נספח א.
על פי התקן, גובה האמבט צריך להיות בין 40-60 ס"מ.
(סטייה זו תקפה כל עוד אין הסכם מפורש בין הקבלן לבעל הנכס על גובה שונה מהנחיות התקן).
נדרש: להתאים את גובה האמבט להנחיות התקן, כך שיהיה בטווח 40-60 ס"מ מפני הריצוף. במקרה של חריגה, יש לבצע תיאום ואישור בכתב בין הקבלן לבעל הנכס.

## שקע חשמל קרובה לברז / Шека хашмаль близка к крану

ליקוי: שקע החשמל הותקן בסמוך לברז ונמצא במקום החשוף למים ומהווה פגיע בטיחותית.
הליקוי אסור ע"פ תקנות החשמל (מעגלים סופיים ותקניים במתח עד 1000 וולט) סעיף 4.
נדרש: להזיז את שקע החשמל למיקום בטוח בהתאם לתקנות החשמל, כך שיהיה רחוק מהברז ואזור החשוף למים.

## שקע חשמל בחוף לא תקינה / Шека хашмаль на кир хицоне ле ткнина

הערה: קיים חשד ששקע החשמל אשר הותקן אינו מותאם להתקנה חיצונית. הרכיב שהותקן מותאם אך ורק לאזורים פנימיים אשר אינם חשופים לאקלים חיצוני.
בשימוש חיצוני כיסוי רכיב החשמל נמוך ומחורר. שקעים המותקנים בחוץ חייבים להיות בעלי הגנה של לפחות IP44 או IP55, בהתאם לתקנות החשמל (מעגלים סופיים ותקניים במתח עד 1000 וולט) סעיף 53.
נדרש: להחליף את שקעי החשמל הקיימים בשקעים תקניים המותאמים להתקנה חיצונית, עם דירוג הגנה IP44 או IP55, בהתאם לתקנות החשמל, ולוודא אטימה מלאה למניעת חדירת מים ולחות.

## גלגלון  כיבוי אש הותקן בלי ארון / Пожарный рукав барабан установлен без арона

ליקוי: התקנת גלגלון הכיבוי בוצעה באופן גלוי וחשוף. צינור הגלגלון אינו מותאם להתקנה חיצונית חשופה. הצנרת אינה מוגנת מפני אקלים חיצוני ובמיוחד מפני חשיפה ממושכת לשמש.
נדרש: יש להשלים התקנת ארון כיבוי תקני.

## חסרה תעלה  מתחת למרזב בחוץ /  Отсутствие желоба таалы под марзевом хицони

ליקוי: בקצה צינור ניקוז מי הגשמים בחצר הבית לא הותקנו שקתות.
שוקת היא אלמנט בטון הממוקם מתחת לפתח צינור הניקוז, שתפקידו לפזר את מי הגשמים בצורה אחידה על פני הקרקע או הרצפה הסמוכה. בהיעדר שקתות, מי הגשמים מתרכזים בנקודה אחת ועלולים לגרום לשקיעת הקרקע וליצירת בורות.
נדרש: יש להשלים התקנת שקתות למניעת שחיקת הקרקע והיווצרות בורות.

## מעקה בחדר מדרגות רופף / Мааке шатается в хедер мадрегот

ליקוי: המעקה אינו מחוזק כראוי לרצפת המבנה, והוא מתנדנד. נראה כי אינו מקובע באופן תקני וחזק מספיק לתשתית הקיימת, וזאת בניגוד לדרישות תקן ישראלי 1142.
נדרש: לחזק ולשפר את העיגון של רכיבי המעקה בהתאם להנחיות המתכנן ולתקנים הרלוונטיים.

## חלון הותקן בצורה לא ישרה קיים מרווח

ליקוי: חלון הותקן בצורה לא ישרה – קיים חוסר אחידות בין החלק העליון לחלק התחתון בצד ימין של המסגרת. המרחקים אינם שווים, דבר הפוגע באסתטיקה ועלול להשפיע גם על האטימה.
בניגוד לתקן: ת"י 1068 חלק 2 – הקובע כי יש להתקין חלונות בצורה מדויקת, אנכית וישרה, תוך הקפדה על רמות אחידות ואטימה מלאה.
נדרש: לפרק ולהתקין את החלון מחדש באופן מדויק וישר, ו/או לבצע תיקון בהתאם.


## חסר מחסום ריח בקופסת הביקורת / хасер махсом реах

ליקוי: חסר מחסום ריח בקופסת הביקורת – דבר שעלול לגרום לחדירת ריחות לא נעימים ממערכת הביוב.
בניגוד לתקן: ת"י 1205 חלק 2 – הקובע כי יש להתקין מחסומי ריח בכל נקודת ביקורת למניעת חדירת גזים ממערכת הביוב.
נדרש: התקנת מחסום ריח תקני בקופסת הביקורת בהתאם לתקנות.

## חסרה פינה חדה

ליקוי: חסרה פינה חדה בחדרי הרחצה, דבר הפוגע בגימור ובאסתטיקה של האריחים במפגש קירות.
בניגוד לתקן: ת"י 789 ות"י 1142 – המחייבים גימור בטיחותי ללא קצוות חדים, בליטות מסוכנות או נגישות לא תקינה.
נדרש: להשלים פינה חדה בהתאם לגמר הנדרש.

## חסר סטופר לדלת / Нет стопера

ליקוי: חסר סטופר לדלת הכניסה, דבר העלול לגרום לפגיעה בקיר או בדלת בעת פתיחה מלאה.
נדרש: התקנת סטופר מתאים למניעת פגיעות בדלת ובקיר.

## משקוף דלת הכניסה לא מגיע עד לרצפה

ליקוי: משקוף דלת הכניסה אינו מגיע עד לרצפה, דבר הפוגע בגימור, באסתטיקה ועלול לאפשר חדירת מים ולכלוך.
נדרש: להשלים את המשקוף עד לרצפה בצורה אחידה ואסתטית.

## אינטרקום לא עובד

ליקוי: מערכת האינטרקום בכניסה אינה פועלת, דבר הפוגע בנוחות וביכולת בקרת הגישה לבניין.
בניגוד לתקן: ת"י 1337 – הקובע כי מערכות בקרת כניסה ואינטרקום חייבות לפעול באופן תקין ולהבטיח תקשורת ובקרה תקינה בין הכניסה לדירות.
נדרש: לאתר את התקלה ולבצע תיקון או החלפה של רכיב/ים לפי הצורך.

## ספרינקלר חלודה

ליקוי: ראש ספרינקלר עם סימני חלודה, העלול לפגוע בתפקוד התקין של המערכת במקרה חירום.​
בניגוד לתקן: ת"י 1928 – "מערכות לכיבוי אש במים: בקרה, בדיקה ותחזוקה", הקובע כי יש לבצע תחזוקה שוטפת ובדיקות תקופתיות למערכות כיבוי אש, כולל בדיקה והחלפה של רכיבים פגומים או חלודים. ​
נדרש: לנקות בעדינות את החלודה מראש הספרינקלר ולבצע טיפול מונע, כגון יישום ספריי נגד חלודה. אם מדובר בראש ספרינקלר פעיל, יש לבצע בדיקת תקינות ולהחליפו במקרה הצורך.​


## מכסה מיזוג אוויר בולט מהתקרה

ליקוי: מכסה שירות למיזוג אוויר בתקרה אינו מותקן כראוי – בולט, עקום ועם מרווחים גלויים, בניגוד לדרישות תקן ת"י 994 לפתחי שירות נסתרים.
נדרש: ליישר את הפתח, לבצע התקנה מחדש או להחליף את המכסה לפי הצורך.

## ספרינקלר התקנה עקומה









ליקוי: ספרינקלר מותקן בצורה עקומה ואינו מיישר עם התקרה, דבר הפוגע באסתטיקה ועלול להשפיע על תפקודו התקין, וזאת בניגוד לתקן 1928.
נדרש: ליישר את הספרינקלר ולהתקינו מחדש לפי התקן.










## זכוכית לכלוך

הערות: על פני הזכוכית נמצאו אבק ולכלוך. הדבר לא אפשר בדיקת זכוכית בוויטרינה בגין שריטות או ש"ע.
יש לבצע ניקוי יסודי של הזכוכית ולבדוק את הזכוכית מבחינת קיום שריטות או ש"ע. במידת הצורך לבצע תיקונים.

## הפרש גובה בין אריחים (לא יהיה גדול מ –1.5 מ"מ) / высота между плитками не больше 1,5 мм

ליקוי: נמצאו הפרשי גובה בין אריחים סמוכים בשיעור של מעל 1.5 מ''מ המקסימאליים, וזאת בניגוד לדרישות ת''י 1555 חלק 2 סעיף 3.2.2.
נדרש: לפרק ריצוף ולבצעו מחדש.

## דלת ממ"ד לא ננעלת הרמטית / дверь мамада очень тяжело закрывается

ליקוי: קושי רב בסגירת דלת הממ"ד .
הליקוי מהווה פגם בטיחותי ונוגד לתקנות ההתגוננות האזרחית סעיף 202, ציטוט: הכניסה למרחב מוגן דירתי תהיה מתוך שטח הדירה ותותקן בה דלת הדף דירתי אשר תהיה אטומה בפני גזים.
ות"י 5044.2

במצב חירום בו אישה או אדם מבוגר יצטרכו לסגור את הדלת ייתכן ולא יצליחו והדלת לא תמלא את תפקידה בהגנת היושבים בחדר האטום במצב חירום. יש לכוון על ידי איש מקצוע.
נדרש: כיוון הדלת ובדיקת אטימות ע"י מעבדה מורשית וקבלת אישור.

## ריצוף דירתי יוצא ללובי/маавар рицпа лоби-дира ликуй

ליקוי: מעבר המודרג מתחת לפלדלת בוצע בצורה אלכסונית ולא מקביל לכנף. כתוצאה מכך ריצוף הפנים פולש החוצה, אל התחום של הלובי קומתי.
נדרש: לבצע תיקוני ריצוף - ליישר קו של מעבר המודרג.

## דלת/ידית  ממ"ד סגירה קשה מעוד / Дверь-ручка мамада очень тяжелое закрытие

ליקוי: סגירת ידית ו/או דלת הממ"ד קשה ודורשת הפעלת כוח רב, מה שעלול לפגוע בתפקוד הדלת ובשימושיותה בעת חירום.
נדרש: לתקן את מנגנון הסגירה או העלייה של הדלת, כולל כיוון, שימון והחלפת רכיבים פגומים במידת הצורך.

## שיפוע לקוי בתוך הדירה/ тротуарная плитка шипуа

ליקוי: אותרו אריחי ריצוף עם שיפוע______ %, במקום להיות אופקיים כקבוע בתקן 1555.3.
מצ"ב ציטוט סעיפים 3.2 ו -5.1.4.5.2 מת"י 1555.3 (תיקון 2014) הדן ב – ריצוף באריחי קרמיקה"

נדרש: לפרק את הריצוף ולבצעו מחדש בצורה מפולסת (אופקית).
&nbsp;

## חנייה : ארון כיבוי אש בתוך החנייה /  Ханая шкаф огнетушитель

ליקוי: מיקום עמדת כיבוי אש בוצע בתוך תא חניה פרטית. הדבר יוצר מצב של הפרעה בשימוש העמדה בזמן שהמכונית חונה.
נדרש: שינוי מיקום ו/או קבלת אישור הסוגיה ע"י יועץ בטיחות בכיבוי אש.
מחיר: ללא עלות כרגע. יש לצרף מחיר לאחר קבלת החלטה באופו התיקון.

## ידית דלת ממ"ד תפקוד לקוי / Ручка двери мамада тяжело закрывается

ליקוי: ידית דלת הממ"ד מתפקדת בקושי וננעלת בצורה קשה. הליקוי מהווה פגם בטיחותי, שכן במצב חירום ייתכן שאישה או אדם מבוגר לא יצליחו לסגור את הדלת, ולכן הדלת לא תספק את ההגנה הנדרשת בחדר האטום.
נדרש: לכוונן את הידית עד שתפעל בצורה חלקה.
`;
